window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match !== null) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size == null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};
		
        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');
		  //adornTm
          $("."+currentOption.index).find(".swatchInput[value='"+currentOption.value+"']").prop("checked", true);
                   
          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#PageContainer, #shopify-section-header')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }


    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen === 'function') {
      this.config.onDrawerOpen();
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on('keyup.drawer', $.proxy(function(evt) {
      // close on 'esc' keypress
      if (evt.keyCode === 27) {
        this.close();
        return false;
      } else {
        return true;
      }
    }, this));

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on('click.drawer', $.proxy(function() {
      this.close();
      return false;
    }, this));
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();


/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function() {
  var selectors = {
    body: 'body',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '.site-nav--has-dropdown',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last'
  };

  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link'
  };

  var cache = {};

  function init() {
    cacheSelectors();

    cache.$parents.on('click.siteNav', function(evt) {
      var $el = $(this);

      if (!$el.hasClass(config.activeClass)) {
        // force stop the click from happening
        evt.preventDefault();
        evt.stopImmediatePropagation();
      }

      showDropdown($el);
    });

    // check when we're leaving a dropdown and close the active dropdown
    $(selectors.siteNavChildLink).on('focusout.siteNav', function() {
      setTimeout(function() {
        if ($(document.activeElement).hasClass(config.childLinkClass) || !cache.$activeDropdown.length) {
          return;
        }

        hideDropdown(cache.$activeDropdown);
      });
    });

    // close dropdowns when on top level nav
    cache.$topLevel.on('focus.siteNav', function() {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    });

    cache.$subMenuLinks.on('click.siteNav', function(evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
    });
  }

  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown)
    };
  }

  function showDropdown($el) {
    $el.addClass(config.activeClass);

    // close open dropdowns
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }

    cache.$activeDropdown = $el;

    // set expanded on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

    setTimeout(function() {
      $(window).on('keyup.siteNav', function(evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el);
        }
      });

      $(selectors.body).on('click.siteNav', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
    $el.removeClass(config.activeClass);

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

    $(selectors.body).off('click.siteNav');
    $(window).off('keyup.siteNav');
  }

  function unload() {
    $(window).off('.siteNav');
    cache.$parents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    $(selectors.siteNavChildLink).off('.siteNav');
    $(selectors.body).off('.siteNav');
  }

  return {
    init: init,
    unload: unload
  };
})();

window.theme = window.theme || {};
theme.Search = (function() {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '#shopify-section-header',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    siteHeaderSearch: '.site-header__search',

    searchDrawer: '.search-bar',
    searchDrawerInput: '.search__input',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit'
  };

  var classes = {
    focus: 'search--focus',
    mobileNavIsOpen: 'js-menu--is-open'
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    initDrawer();
    searchSubmit();

    $(selectors.searchHeaderInput).add(selectors.searchHeaderSubmit).on('focus blur', function() {
      $(selectors.searchHeader).toggleClass(classes.focus);
    });

    $(selectors.siteHeaderSearchToggle).on('click', function() {
      $(selectors.searchDrawer).addClass('active');
      $('.customer-links').slideUp('fast');
      if (theme.CartDrawer && typeof theme.CartDrawer.close === 'function') {
        theme.CartDrawer.close();
      }
    });
    
    // Clicking outside makes the results disappear.
    $('#PageContainer').bind('click', function(){
      $('.search-results').hide();
    });
    
    // Current Ajax request.
    var currentAjaxRequest = null;
    var searchForms = $('form[action="/search"]').css('position','relative').each(function() {
      var input = $(this).find('input[name="q"]');
      // Adding a list for showing search results.
      var offSet = input.position().top + input.innerHeight();
      $('<ul class="search-results"></ul>').appendTo($(this)).hide();
      // Listening to keyup and change on the text field within these search forms.
      input.attr('autocomplete', 'off').bind('keyup change', function() {
        // What's the search term?
        var term = $(this).val();
        // What's the search form?
        var form = $(this).closest('form');
        // What's the search URL?
        var searchURL = '/search?type=product&q=' + term;
        // What's the search results list?
        var resultsList = form.find('.search-results');
        // If that's a new term and it contains at least 3 characters.
        if (term.length > 3 && term != $(this).attr('data-old-term')) {
          // Saving old query.
          $(this).attr('data-old-term', term);
          // Killing any Ajax request that's currently being processed.
          if (currentAjaxRequest != null) currentAjaxRequest.abort();
          // Pulling results.
          currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
            // Reset results.
            resultsList.empty();
            // If we have no results.
            if(data.results_count == 0) {
              // resultsList.html('<li><span class="title">No results.</span></li>');
              // resultsList.fadeIn(200);
              resultsList.hide();
            } else {
              // If we have results.
              $.each(data.results, function(index, item) {
                var link = $('<a></a>').attr('href', item.url);
                link.append('<span class="thumbnail"><img src="' + item.thumbnail + '" /></span><div class="disc"><span class="title">' + item.title + '</span><span class="price">' + theme.Currency.formatMoney(item.price, theme.moneyFormat) + '</span></div>');
                link.wrap('<li></li>');
                resultsList.append(link.parent());
              });
              // The Ajax request will return at the most 10 results.
              // If there are more than 10, let's link to the search results page.
              if(data.results_count > 10) {
                resultsList.append('<li class="more"><i class="ad ad-arrow-cir-right"></i><span class="title"><a href="' + searchURL + '">See all results (' + data.results_count + ')</a></span></li>');
              }
              resultsList.fadeIn(200);
            }        
          });
        }
      });
    });
  }

  function initDrawer() {
    // Add required classes to HTML
    $('#PageContainer').addClass('drawer-page-content');
    $('.js-drawer-open-top').attr('aria-controls', 'SearchDrawer').attr('aria-expanded', 'false');

    theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: searchDrawerFocus
    });
  }

  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput));
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchSubmit() {
    $(selectors.searchSubmit).on('click', function(evt) {
      var $el = $(evt.target);
      var $input = $el.parents(selectors.search).find(selectors.searchInput);
      if ($input.val().length === 0) {
        evt.preventDefault();
        searchFocus($input);
      }
    });
  }

  return {
    init: init
  };
})();

window.theme = window.theme || {};

theme.CartHelpers = (function() {
  function showCartError(message) {
    $('.modal').not('#errorDrawer').stop(true, true).hide();
    $('.error-message').text(message);
    $('body').addClass('showOverly show-cart-error').removeClass('loading');
    $('.modalOverly').stop(true, true).fadeIn(250);
    $('#errorDrawer').stop(true, true).show().css({
      display: 'block',
      opacity: 1,
      visibility: 'visible'
    });
  }

  function hideCartError() {
    $('#errorDrawer').stop(true, true).fadeOut(200);
    $('.modalOverly').stop(true, true).fadeOut(200);
    $('body').removeClass('showOverly show-cart-error loading');
  }

  $(document).on('click.cartErrorDismiss', '.modalOverly', function(evt) {
    if (!$('body').hasClass('show-cart-error')) {
      return;
    }
    evt.preventDefault();
    evt.stopPropagation();
    hideCartError();
  });

  $(document).on('click.cartErrorDismiss', '#errorDrawer .closeDrawer, #errorDrawer .errorDrawer__close', function(evt) {
    evt.preventDefault();
    hideCartError();
  });

  function formatMessage(template, values) {
    var msg = template || '';
    Object.keys(values).forEach(function(key) {
      msg = msg.split('{{ ' + key + ' }}').join(values[key]);
      msg = msg.split('{{' + key + '}}').join(values[key]);
    });
    return msg;
  }

  function findVariantData(variantId) {
    variantId = parseInt(variantId, 10);
    if (!variantId) {
      return null;
    }

    var $pvr = $('#pvr-' + variantId);
    if ($pvr.length) {
      var domQty = parseInt($pvr.text(), 10);
      return {
        id: variantId,
        inventory_management: 'shopify',
        inventory_policy: 'deny',
        inventory_quantity: isNaN(domQty) ? 0 : domQty
      };
    }

    var scripts = document.querySelectorAll('script[id^="ProductJson-"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var product = JSON.parse(scripts[i].innerHTML);
        if (!product || !product.variants) {
          continue;
        }
        for (var j = 0; j < product.variants.length; j++) {
          if (parseInt(product.variants[j].id, 10) === variantId) {
            return product.variants[j];
          }
        }
      } catch (error) {
        continue;
      }
    }

    return null;
  }

  function getProductIdFromVariant(variantId) {
    variantId = parseInt(variantId, 10);
    if (!variantId) {
      return null;
    }

    var scripts = document.querySelectorAll('script[id^="ProductJson-"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var product = JSON.parse(scripts[i].innerHTML);
        if (!product || !product.variants) {
          continue;
        }
        for (var j = 0; j < product.variants.length; j++) {
          if (parseInt(product.variants[j].id, 10) === variantId) {
            return product.id;
          }
        }
      } catch (error) {
        continue;
      }
    }

    return null;
  }

  function getExcludeProductIds(cart, addingProductId) {
    var ids = [];

    if (cart && cart.items) {
      cart.items.forEach(function(item) {
        if (item.product_id) {
          ids.push(item.product_id);
        }
      });
    }

    if (addingProductId && ids.indexOf(addingProductId) === -1) {
      ids.push(addingProductId);
    }

    return ids;
  }

  function fetchVariantData(variantId) {
    return fetch('/variants/' + variantId + '.js', {
      headers: { 'Accept': 'application/json' }
    }).then(function(response) {
      if (!response.ok) {
        return null;
      }
      return response.json();
    }).catch(function() {
      return null;
    });
  }

  function getInventoryLimit(variant) {
    if (!variant || variant.inventory_management !== 'shopify') {
      return null;
    }
    if (variant.inventory_policy === 'continue') {
      return null;
    }

    var qty = parseInt(variant.inventory_quantity, 10);
    return isNaN(qty) ? null : qty;
  }

  function getCartVariantQty(variantId, cart) {
    if (!cart || !cart.items) {
      return 0;
    }

    variantId = parseInt(variantId, 10);
    var total = 0;

    cart.items.forEach(function(item) {
      if (parseInt(item.variant_id, 10) === variantId) {
        total += parseInt(item.quantity, 10) || 0;
      }
    });

    return total;
  }

  function getInventoryErrorMessage(availableQty, inCart, stockLimit) {
    if (inCart > 0 && availableQty < stockLimit) {
      return formatMessage(theme.strings.inventoryLimitAddError, {
        quantity: availableQty,
        total: stockLimit
      });
    }

    return formatMessage(theme.strings.inventoryLimitError, {
      quantity: stockLimit
    });
  }

  function validateAddQuantity(variantId, addQty, cart) {
    addQty = parseInt(addQty, 10) || 1;
    var variant = findVariantData(variantId);
    var limit = getInventoryLimit(variant);

    if (limit === null) {
      return { valid: true };
    }

    cart = cart || (window.CartJS ? CartJS.cart : null);
    var inCart = getCartVariantQty(variantId, cart);
    var maxAddable = limit - inCart;

    if (maxAddable <= 0) {
      return {
        valid: false,
        message: formatMessage(theme.strings.inventoryLimitError, {
          quantity: limit
        })
      };
    }

    if (addQty > maxAddable) {
      return {
        valid: false,
        message: getInventoryErrorMessage(maxAddable, inCart, limit)
      };
    }

    return { valid: true };
  }

  function validateLineQuantity(variantId, newQty) {
    newQty = parseInt(newQty, 10);
    if (isNaN(newQty) || newQty < 0) {
      newQty = 0;
    }

    var variant = findVariantData(variantId);
    var limit = getInventoryLimit(variant);

    if (limit === null) {
      return { valid: true };
    }

    if (newQty > limit) {
      return {
        valid: false,
        maxQuantity: limit,
        message: getInventoryErrorMessage(limit, 0, limit)
      };
    }

    return { valid: true, maxQuantity: limit };
  }

  function validateAddQuantityAsync(variantId, addQty, cart) {
    var syncResult = validateAddQuantity(variantId, addQty, cart);
    if (syncResult.valid || findVariantData(variantId)) {
      return Promise.resolve(syncResult);
    }

    return fetchVariantData(variantId).then(function(variant) {
      if (!variant) {
        return { valid: true };
      }

      var limit = getInventoryLimit(variant);
      if (limit === null) {
        return { valid: true };
      }

      var inCart = getCartVariantQty(variantId, cart);
      var maxAddable = limit - inCart;

      if (addQty > maxAddable) {
        return {
          valid: false,
          message: getInventoryErrorMessage(Math.max(maxAddable, 0), inCart, limit)
        };
      }

      return { valid: true };
    });
  }

  function validateLineQuantityAsync(variantId, newQty) {
    var syncResult = validateLineQuantity(variantId, newQty);
    if (syncResult.valid || findVariantData(variantId)) {
      return Promise.resolve(syncResult);
    }

    return fetchVariantData(variantId).then(function(variant) {
      if (!variant) {
        return { valid: true };
      }

      var limit = getInventoryLimit(variant);
      if (limit === null || newQty <= limit) {
        return { valid: true };
      }

      return {
        valid: false,
        maxQuantity: limit,
        message: getInventoryErrorMessage(limit, 0, limit)
      };
    });
  }

  function applyLineQuantityWithInventoryCheck(line, newQty, $input, previousQty) {
    if (!window.CartJS || !CartJS.cart || !CartJS.cart.items) {
      return Promise.resolve();
    }

    var item = CartJS.cart.items[line - 1];
    if (!item) {
      return Promise.resolve();
    }

    if (typeof previousQty === 'undefined') {
      previousQty = item.quantity;
    }

    newQty = parseInt(newQty, 10);
    if (isNaN(newQty) || newQty < 1) {
      newQty = 1;
    }

    return validateLineQuantityAsync(item.variant_id, newQty).then(function(validation) {
      if (!validation.valid) {
        var maxQty = validation.maxQuantity;

        if (maxQty && maxQty >= 1) {
          showCartError(validation.message);

          if ($input && $input.length) {
            $input.val(maxQty);
          }

          if (maxQty !== previousQty) {
            return changeLine(line, maxQty);
          }

          return;
        }

        if ($input && $input.length) {
          $input.val(previousQty);
        }
        showCartError(validation.message);
        return;
      }

      return changeLine(line, newQty);
    });
  }

  function getActiveSellingPlanId() {
    var widget = document.querySelector('.product-form .appstle_sub_widget:not(:empty), #ProductSection .appstle_sub_widget:not(:empty)');
    if (!widget) {
      return null;
    }

    var selected = widget.querySelector('input[type="radio"]:checked');
    if (!selected || !selected.value) {
      return null;
    }

    var planId = parseInt(selected.value, 10);
    if (!planId || planId < 1) {
      return null;
    }

    return planId;
  }

  function buildAddItem(variantId, qty, skipSellingPlan) {
    var parsedId = parseInt(variantId, 10);
    if (!parsedId || isNaN(parsedId)) {
      return null;
    }

    var item = {
      id: parsedId,
      quantity: parseInt(qty, 10) || 1
    };

    if (!skipSellingPlan) {
      var planId = getActiveSellingPlanId();
      if (planId) {
        item.selling_plan = planId;
      }
    }

    return item;
  }

  function fetchCartAdd(variantId, qty, options) {
    options = options || {};
    var cart = window.CartJS ? CartJS.cart : null;
    var addingProductId = getProductIdFromVariant(variantId);

    if (!options.skipRecommendations && addingProductId && theme.CartDrawer && typeof theme.CartDrawer.showInstantRecommendations === 'function') {
      theme.CartDrawer.showInstantRecommendations(addingProductId, getExcludeProductIds(cart, addingProductId));
    }

    return validateAddQuantityAsync(variantId, qty, cart).then(function(validation) {
      if (!validation.valid) {
        return Promise.reject({ description: validation.message, inventory: true });
      }

      var addItem = buildAddItem(variantId, qty, options.skipSellingPlan);
      if (!addItem) {
        return Promise.reject({ description: 'Please select a valid product option before adding to cart.' });
      }

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [addItem]
        })
      }).then(function(response) {
        if (!response.ok) {
          return response.json().then(function(errorBody) {
            throw errorBody;
          });
        }
        return response.json();
      }).then(function() {
        return fetch('/cart.js', {
          headers: { 'Accept': 'application/json' }
        }).then(function(response) {
          return response.json();
        });
      });
    });
  }

  function findCartItemByKey(itemKey) {
    if (!window.CartJS || !CartJS.cart || !CartJS.cart.items || !itemKey) {
      return null;
    }

    for (var i = 0; i < CartJS.cart.items.length; i++) {
      if (CartJS.cart.items[i].key === itemKey) {
        return CartJS.cart.items[i];
      }
    }

    return null;
  }

  function snapshotCart(cart) {
    try {
      return JSON.parse(JSON.stringify(cart));
    } catch (error) {
      return cart;
    }
  }

  function buildOptimisticCartAfterRemove(cart, itemKey) {
    if (!cart || !cart.items) {
      return cart;
    }

    var optimistic = snapshotCart(cart);
    var removedItem = null;
    var items = [];

    optimistic.items.forEach(function(item) {
      if (item.key === itemKey) {
        removedItem = item;
      } else {
        items.push(item);
      }
    });

    if (!removedItem) {
      return optimistic;
    }

    var item_count = 0;
    items.forEach(function(item) {
      item_count += parseInt(item.quantity, 10) || 0;
    });

    optimistic.items = items;
    optimistic.item_count = item_count;
    optimistic.total_price = Math.max(0, (parseInt(optimistic.total_price, 10) || 0) - (parseInt(removedItem.line_price, 10) || 0));

    return optimistic;
  }

  function updateCartDrawerTotals(cart) {
    if (!cart) {
      return;
    }

    $('[data-cart-render="item_count"], .site-header__cart-count').text(cart.item_count);

    if (window.theme && theme.Currency && theme.Currency.formatMoney && theme.moneyFormat) {
      $('#CartDrawer .cart-drawer__subtotal-price').html(
        theme.Currency.formatMoney(cart.total_price, theme.moneyFormat)
      );
    }
  }

  function syncCartData(cart, options) {
    options = options || {};

    if (!cart) {
      return;
    }

    if (window.CartJS && CartJS.cart) {
      if (typeof CartJS.cart.update === 'function') {
        CartJS.cart.update(cart);
      } else {
        CartJS.cart = cart;
      }

      if (theme.CartHelpers && theme.CartHelpers.enrichCartSubscriptionLabels) {
        theme.CartHelpers.enrichCartSubscriptionLabels(CartJS.cart);
      }

      if (!options.skipRender) {
        CartJS.render({}, CartJS.cart);
      }
    }

    updateCartDrawerTotals(cart);
  }

  var pendingRemoveKeys = {};

  function resolveCartItemKey($btn) {
    if (!window.CartJS || !CartJS.cart || !CartJS.cart.items || !$btn || !$btn.length) {
      return null;
    }

    var line = parseInt($btn.attr('data-cart-remove-line'), 10);
    if (line && CartJS.cart.items[line - 1] && CartJS.cart.items[line - 1].key) {
      return CartJS.cart.items[line - 1].key;
    }

    var itemKey = $btn.attr('data-item-key');
    if (itemKey) {
      return itemKey;
    }

    var $row = $btn.closest('.cart-drawer__item');
    var rowIndex = $('#CartDrawer .cart-drawer__items .cart-drawer__item').index($row);
    if (rowIndex >= 0 && CartJS.cart.items[rowIndex] && CartJS.cart.items[rowIndex].key) {
      return CartJS.cart.items[rowIndex].key;
    }

    return null;
  }

  function removeItemByKey(itemKey) {
    if (!window.CartJS || !CartJS.cart) {
      return Promise.reject({ description: 'Cart item not found.' });
    }

    if (!itemKey || !findCartItemByKey(itemKey)) {
      return Promise.reject({ description: 'Cart item not found.' });
    }

    if (pendingRemoveKeys[itemKey]) {
      return pendingRemoveKeys[itemKey];
    }

    var request = fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: 0
      })
    }).then(function(response) {
      if (!response.ok) {
        return response.json().then(function(errorBody) {
          throw errorBody;
        });
      }
      return response.json();
    }).then(function(cart) {
      enrichCartSubscriptionLabels(cart);
      applyCartState(cart, { openDrawer: false, skipRecommendations: true });
      return cart;
    }).catch(function(errorBody) {
      return fetch('/cart.js', {
        headers: { 'Accept': 'application/json' }
      }).then(function(response) {
        return response.json();
      }).then(function(cart) {
        enrichCartSubscriptionLabels(cart);
        applyCartState(cart, { openDrawer: false, skipRecommendations: true });
        throw errorBody;
      });
    }).finally(function() {
      delete pendingRemoveKeys[itemKey];
    });

    pendingRemoveKeys[itemKey] = request;
    return request;
  }

  function changeItemByKey(itemKey, quantity) {
    quantity = parseInt(quantity, 10);

    if (quantity === 0) {
      return removeItemByKey(itemKey);
    }

    var item = findCartItemByKey(itemKey);

    if (!item) {
      return Promise.reject({ description: 'Cart item not found.' });
    }

    return changeLineItem(item, quantity);
  }

  function changeLine(line, quantity) {
    if (!window.CartJS || !CartJS.cart || !CartJS.cart.items || !CartJS.cart.items[line - 1]) {
      return Promise.reject({ description: 'Cart item not found.' });
    }

    return changeLineItem(CartJS.cart.items[line - 1], quantity);
  }

  function changeLineItem(item, quantity) {
    var variantId = item.variant_id;
    var itemKey = item.key;
    quantity = parseInt(quantity, 10);

    function performChange() {
      $('#CartDrawer').addClass('is-updating');

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: quantity
        })
      }).then(function(response) {
        if (!response.ok) {
          return response.json().then(function(errorBody) {
            throw errorBody;
          });
        }
        return response.json();
      }).then(function(cart) {
        applyCartState(cart, { openDrawer: false });
        return cart;
      }).catch(function(errorBody) {
        return fetch('/cart.js', {
          headers: { 'Accept': 'application/json' }
        }).then(function(response) {
          return response.json();
        }).then(function(cart) {
          applyCartState(cart, { openDrawer: false });
          throw errorBody;
        });
      }).finally(function() {
        $('#CartDrawer').removeClass('is-updating');
      });
    }

    if (quantity === 0) {
      return performChange();
    }

    return validateLineQuantityAsync(variantId, quantity).then(function(validation) {
      if (!validation.valid) {
        return Promise.reject({ description: validation.message, inventory: true });
      }

      return performChange();
    });
  }

  function enrichCartSubscriptionLabels(cart) {
    if (!cart || !cart.items) {
      return;
    }

    cart.items.forEach(function(item) {
      var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
      item.subscriptionLabel = plan && plan.name ? plan.name : '';
    });
  }

  function closeQuickViewPopup() {
    if (typeof $.magnificPopup !== 'undefined' && $.magnificPopup.close) {
      $.magnificPopup.close();
    }
  }

  function applyCartState(cart, options) {
    options = options || {};

    if (theme.Cart && theme.Cart.updateHeaderCartCount) {
      theme.Cart.updateHeaderCartCount(cart, { skipRender: !!options.skipRender });
    }

    if (options.skipRender) {
      updateCartDrawerTotals(cart);
    }

    $(document).trigger('cart.requestComplete', [cart, $.extend({ skipCartRender: true }, options)]);

    if (options.openDrawer !== false && theme.CartDrawer && typeof theme.CartDrawer.open === 'function') {
      closeQuickViewPopup();
      theme.CartDrawer.open({ skipSync: true });
    }
  }

  return {
    fetchCartAdd: fetchCartAdd,
    changeLine: changeLine,
    changeItemByKey: changeItemByKey,
    removeItemByKey: removeItemByKey,
    resolveCartItemKey: resolveCartItemKey,
    syncCartData: syncCartData,
    updateCartDrawerTotals: updateCartDrawerTotals,
    applyCartState: applyCartState,
    closeQuickViewPopup: closeQuickViewPopup,
    applyLineQuantityWithInventoryCheck: applyLineQuantityWithInventoryCheck,
    showCartError: showCartError,
    hideCartError: hideCartError,
    validateAddQuantity: validateAddQuantity,
    validateLineQuantity: validateLineQuantity,
    validateLineQuantityAsync: validateLineQuantityAsync,
    enrichCartSubscriptionLabels: enrichCartSubscriptionLabels,
    getActiveSellingPlanId: getActiveSellingPlanId
  };
})();

theme.CartDrawer = (function() {
  var selectors = {
    drawer: '#CartDrawer',
    close: '.js-drawer-close',
    open: '.js-drawer-open-right',
    page: '#PageContainer, #shopify-section-header',
    recommendations: '#CartDrawerRecommendations',
    recommendationsList: '#CartDrawerRecommendationsList',
    recommendationsPrev: '.cart-drawer__recommendations-arrow--prev',
    recommendationsNext: '.cart-drawer__recommendations-arrow--next'
  };

  var $drawer = null;
  var $overlay = null;
  var $html = null;
  var isOpen = false;
  var recommendationsRequest = null;
  var lastRecommendationKey = '';
  var lastRecommendationProductKey = '';
  var cachedRecommendationProducts = [];
  var prefetchedByProductId = {};
  var cachedFallbackProducts = [];
  var openRefreshTimer = null;
  var drawerTransitionMs = 280;
  var recommendationsLoadTimer = null;

  function showCheckoutAgreement() {
    var $modal = $('#cartCheckoutAgreement');

    if (!$modal.length) {
      return;
    }

    $modal.removeAttr('hidden');
    $('body').addClass('showOverly show-cart-checkout-agreement');
  }

  function hideCheckoutAgreement() {
    $('body').removeClass('showOverly show-cart-checkout-agreement');
    $('#cartCheckoutAgreement').attr('hidden', 'hidden');
  }

  function getCheckoutAckGroup($el) {
    return $el.closest('.cart-checkout-ack-group');
  }

  function updateCheckoutAckGroup($group) {
    if (!$group.length || !$('#cartCheckoutAgreement').length) {
      return;
    }

    var $checkbox = $group.find('.js-cart-checkout-agreement-checkbox');
    var $checkout = $group.find('.js-cart-checkout-button');

    if (!$checkbox.length || !$checkout.length) {
      return;
    }

    var isChecked = $checkbox.is(':checked');
    $checkout.toggleClass('is-disabled', !isChecked).attr('aria-disabled', !isChecked ? 'true' : 'false');

    if ($checkout.is('input, button')) {
      $checkout.prop('disabled', !isChecked);
    }

    if (isChecked) {
      $group.find('.cart-checkout-ack').removeClass('is-required');
    }
  }

  function updateCheckoutAgreementState() {
    $('.cart-checkout-ack-group').each(function() {
      updateCheckoutAckGroup($(this));
    });
  }

  function resetCheckoutAgreement() {
    $('.js-cart-checkout-agreement-checkbox').prop('checked', false);
    updateCheckoutAgreementState();
  }

  function bindCheckoutAgreement() {
    $(document).on('click.cartCheckoutAgreement mousedown.cartCheckoutAgreement', '.js-cart-checkout-agreement-link', function(evt) {
      evt.preventDefault();
      evt.stopPropagation();

      if (evt.type === 'click') {
        showCheckoutAgreement();
      }
    });

    $(document).on('change.cartCheckoutAgreement', '.js-cart-checkout-agreement-checkbox', function() {
      updateCheckoutAckGroup(getCheckoutAckGroup($(this)));
    });

    $(document).on('click.cartCheckoutAgreement', '.js-cart-checkout-button', function(evt) {
      if (!$('#cartCheckoutAgreement').length) {
        return;
      }

      var $group = getCheckoutAckGroup($(this));
      var $checkbox = $group.find('.js-cart-checkout-agreement-checkbox');

      if ($checkbox.length && !$checkbox.is(':checked')) {
        evt.preventDefault();
        $group.find('.cart-checkout-ack').addClass('is-required');
      }
    });

    $(document).on('submit.cartCheckoutAgreement', 'form.cart', function(evt) {
      if (!$('#cartCheckoutAgreement').length) {
        return;
      }

      var submitter = evt.originalEvent && evt.originalEvent.submitter;
      if (submitter && submitter.name !== 'checkout') {
        return;
      }

      var $group = $(this).find('.cart-checkout-ack-group');
      var $checkbox = $group.find('.js-cart-checkout-agreement-checkbox');

      if ($checkbox.length && !$checkbox.is(':checked')) {
        evt.preventDefault();
        $group.find('.cart-checkout-ack').addClass('is-required');
      }
    });

    $(document).on('click.cartCheckoutAgreement', '#cartCheckoutAgreement .cart-checkout-agreement__close', function(evt) {
      evt.preventDefault();
      hideCheckoutAgreement();
    });

    $(document).on('click.cartCheckoutAgreement', '.modalOverly', function() {
      if ($('body').hasClass('show-cart-checkout-agreement')) {
        hideCheckoutAgreement();
      }
    });

    $(document).on('keyup.cartCheckoutAgreement', function(evt) {
      if (evt.key === 'Escape' && $('body').hasClass('show-cart-checkout-agreement')) {
        hideCheckoutAgreement();
      }
    });

    updateCheckoutAgreementState();
  }

  function initCheckoutAgreement() {
    bindCheckoutAgreement();
  }

  function init() {
    $drawer = $(selectors.drawer);
    if (!$drawer.length) {
      return;
    }

    $overlay = $('#CartDrawerOverlay');
    $html = $('html');
    $('#PageContainer').addClass('drawer-page-content');
    $(selectors.open).attr('aria-controls', 'CartDrawer').attr('aria-expanded', 'false');

    $(document).on('click.cartDrawerOpen', selectors.open, function(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      if (isOpen) {
        close();
      } else {
        open();
      }
    });

    $drawer.on('click.cartDrawerClose', selectors.close, function(evt) {
      evt.preventDefault();
      close();
    });

    bindQuantityControls();
    bindRemoveControls();
    bindRecommendationAdds();

    $(document).on('click', '.js-open-cart-drawer', function(evt) {
      evt.preventDefault();
      open();
    });

    $(document).on('cart.requestComplete', function(event, cart, options) {
      syncCart(cart, options || {});
    });

    $(document).on('cart.synced', function(event, cart) {
      scheduleRecommendationsLoad(cart);
    });

    $(window).on('pageshow.cartDrawer', function(event) {
      if (event.originalEvent && event.originalEvent.persisted) {
        refresh(true);
      }
    });

    $(document).on('visibilitychange.cartDrawer', function() {
      if (!document.hidden && isOpen) {
        refresh(false);
      }
    });

    $(window).on('resize.cartDrawerRecs', function() {
      refreshRecommendationsSlider();
    });

    if (window.CartJS && CartJS.cart && CartJS.cart.item_count > 0) {
      loadRecommendations(CartJS.cart);
    }

    loadEmbeddedFallbackProducts();
    prefetchFallbackProducts();

    var $recList = $(selectors.recommendationsList);
    var $recWrap = $(selectors.recommendations);
    if ($recList.children().length && $recWrap.length && !$recWrap.is('[hidden]')) {
      initRecommendationsSlider();
    }
  }

  function getDrawerEl() {
    return $drawer && $drawer.length ? $drawer : $(selectors.drawer);
  }

  function getRecommendationsLimit() {
    return parseInt(getDrawerEl().data('recommendations-limit'), 10) || 4;
  }

  function loadEmbeddedFallbackProducts() {
    var $json = $('#CartDrawerFallbackProductsJson');
    if (!$json.length) {
      return;
    }

    try {
      var products = JSON.parse($json.text());
      if (products && products.length) {
        cachedFallbackProducts = products;
      }
    } catch (error) {
      // Ignore invalid embedded fallback JSON.
    }
  }

  function filterRecommendationProducts(products, excludeIds, limit) {
    limit = limit || getRecommendationsLimit();

    return (products || []).filter(function(product) {
      return !excludeIds || excludeIds.indexOf(product.id) === -1;
    }).slice(0, limit);
  }

  function cachePrefetchedProducts(productId, products) {
    if (productId && products && products.length) {
      prefetchedByProductId[productId] = products;
    }
  }

  function prefetchForProduct(productId) {
    productId = parseInt(productId, 10);
    if (!productId) {
      return $.Deferred().resolve([]).promise();
    }

    if (prefetchedByProductId[productId]) {
      return $.Deferred().resolve(prefetchedByProductId[productId]).promise();
    }

    var $drawer = getDrawerEl();
    if ($drawer.data('show-recommendations') === false || $drawer.data('show-recommendations') === 'false') {
      return $.Deferred().resolve([]).promise();
    }

    var limit = getRecommendationsLimit();

    return $.getJSON('/recommendations/products.json', {
      product_id: productId,
      limit: limit + 4,
      intent: 'related'
    }).then(function(data) {
      var products = data.products || [];
      cachePrefetchedProducts(productId, products);
      return products;
    }, function() {
      return [];
    });
  }

  function prefetchFallbackProducts() {
    var $drawer = getDrawerEl();
    if ($drawer.data('show-recommendations') === false || $drawer.data('show-recommendations') === 'false') {
      return;
    }

    if (cachedFallbackProducts.length) {
      return;
    }

    var collectionHandle = $drawer.data('fallback-collection');
    if (!collectionHandle) {
      return;
    }

    $.getJSON('/collections/' + collectionHandle + '/products.json', {
      limit: getRecommendationsLimit() + 4
    }).done(function(data) {
      cachedFallbackProducts = data.products || [];
    });
  }

  function showInstantRecommendations(productId, excludeIds) {
    var $drawer = getDrawerEl();
    if ($drawer.data('show-recommendations') === false || $drawer.data('show-recommendations') === 'false') {
      return;
    }

    productId = parseInt(productId, 10);
    excludeIds = excludeIds || [];
    var limit = getRecommendationsLimit();
    var products = filterRecommendationProducts(prefetchedByProductId[productId], excludeIds, limit);

    if (!products.length) {
      products = filterRecommendationProducts(cachedFallbackProducts, excludeIds, limit);
    }

    if (products.length) {
      renderRecommendations(products);
      return;
    }

    prefetchForProduct(productId).done(function(prefetched) {
      products = filterRecommendationProducts(prefetched, excludeIds, limit);
      if (!products.length) {
        products = filterRecommendationProducts(cachedFallbackProducts, excludeIds, limit);
      }
      if (products.length) {
        renderRecommendations(products);
      }
    });
  }

  function preventPageScroll(evt) {
    if ($(evt.target).closest('#CartDrawer').length) {
      return;
    }
    evt.preventDefault();
  }

  function lockPageScroll() {
    document.addEventListener('touchmove', preventPageScroll, { passive: false });
    document.addEventListener('wheel', preventPageScroll, { passive: false });
    $html.addClass('cart-drawer-open');
  }

  function unlockPageScroll() {
    document.removeEventListener('touchmove', preventPageScroll, { passive: false });
    document.removeEventListener('wheel', preventPageScroll, { passive: false });
    $html.removeClass('cart-drawer-open');
  }

  function bindOverlayEvents() {
    $overlay.on('click.cartDrawerOverlay', function() {
      close();
    });

    $(document).on('keyup.cartDrawerOverlay', function(evt) {
      if (evt.keyCode === 27) {
        close();
      }
    });
  }

  function unbindOverlayEvents() {
    $overlay.off('.cartDrawerOverlay');
    $(document).off('keyup.cartDrawerOverlay');
  }

  function syncCart(cart, options) {
    options = options || {};

    if (!options.skipCartRender && theme.Cart && theme.Cart.updateHeaderCartCount) {
      theme.Cart.updateHeaderCartCount(cart);
    }

    var productKey = getCartProductIds(cart).join(',');
    if (productKey !== lastRecommendationProductKey) {
      lastRecommendationProductKey = productKey;
      if (!options.skipRecommendations) {
        lastRecommendationKey = '';
        scheduleRecommendationsLoad(cart);
      }
    }
  }

  function scheduleRecommendationsLoad(cart) {
    clearTimeout(recommendationsLoadTimer);
    recommendationsLoadTimer = setTimeout(function() {
      loadRecommendations(cart);
    }, 200);
  }

  function scheduleRefreshAfterOpen() {
    clearTimeout(openRefreshTimer);
    openRefreshTimer = setTimeout(function() {
      refresh(true);
      refreshRecommendationsSlider();
    }, drawerTransitionMs);
  }

  function refresh(forceSync) {
    if (!forceSync) {
      return $.Deferred().resolve().promise();
    }

    lastRecommendationKey = '';

    if (theme.Cart && theme.Cart.syncFromServer) {
      return theme.Cart.syncFromServer();
    }

    var deferred = $.Deferred();
    deferred.resolve();
    return deferred.promise();
  }

  function closeOverlappingModals() {
    if (theme.CartHelpers && typeof theme.CartHelpers.closeQuickViewPopup === 'function') {
      theme.CartHelpers.closeQuickViewPopup();
      return;
    }

    if (typeof $.magnificPopup !== 'undefined' && $.magnificPopup.close) {
      $.magnificPopup.close();
    }
  }

  function open(options) {
    options = options || {};

    if (!$drawer.length) {
      return;
    }

    closeOverlappingModals();

    var wasOpen = isOpen;

    if (!isOpen) {
      isOpen = true;
      $drawer.removeClass('is-active');
      $html.removeClass('cart-drawer-open');
      void $drawer[0].offsetWidth;

      lockPageScroll();
      $overlay.attr('aria-hidden', 'false');
      $(selectors.open).attr('aria-expanded', 'true');

      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          $drawer.addClass('is-active');
        });
      });

      bindOverlayEvents();
      resetCheckoutAgreement();
    }

    var cart = window.CartJS ? CartJS.cart : null;
    var $recWrap = $(selectors.recommendations);
    var $recList = $(selectors.recommendationsList);

    if (cart && cart.item_count > 0 && cart.items[0].product_id) {
      if ($recWrap.is('[hidden]') || !$recList.children().length) {
        showInstantRecommendations(cart.items[0].product_id, getCartProductIds(cart));
      }
    }

    loadRecommendations(cart);
    refreshRecommendationsSlider();

    if (options.skipSync) {
      return;
    }

    if (!wasOpen) {
      scheduleRefreshAfterOpen();
    }
  }

  function close() {
    if (!isOpen || !$drawer.length) {
      return;
    }

    clearTimeout(openRefreshTimer);
    isOpen = false;

    $drawer.removeClass('is-active');
    unlockPageScroll();
    $overlay.attr('aria-hidden', 'true');
    $(selectors.open).attr('aria-expanded', 'false');

    unbindOverlayEvents();
  }

  function bindQuantityControls() {
    $(document).on('click', selectors.drawer + ' [data-cart-qty-plus]', function(evt) {
      evt.preventDefault();
      updateLineQuantity($(this).data('cart-qty-plus'), 1);
    });

    $(document).on('click', selectors.drawer + ' [data-cart-qty-minus]', function(evt) {
      evt.preventDefault();
      updateLineQuantity($(this).data('cart-qty-minus'), -1);
    });

    $(document).on('input.cartDrawerQty', selectors.drawer + ' .cart-drawer__qty-input', function() {
      var $input = $(this);
      var val = String($input.val()).replace(/[^\d]/g, '');

      if (val === '') {
        return;
      }

      if (parseInt(val, 10) < 1) {
        $input.val('1');
        return;
      }

      $input.val(String(parseInt(val, 10)));
    });

    $(document).on('blur.cartDrawerQty', selectors.drawer + ' .cart-drawer__qty-input', function() {
      commitCartDrawerQty($(this));
    });

    $(document).on('keydown.cartDrawerQty', selectors.drawer + ' .cart-drawer__qty-input', function(evt) {
      if (evt.key === 'Enter') {
        evt.preventDefault();
        $(this).blur();
      }
    });
  }

  function normalizeCartDrawerQty(val) {
    val = parseInt(val, 10);
    if (isNaN(val) || val < 1) {
      return 1;
    }
    return val;
  }

  function setQtyLoading($input, isLoading) {
    if (!$input || !$input.length) {
      return;
    }

    var $wrap = $input.closest('.cart-drawer__qty');
    $wrap.toggleClass('is-loading', !!isLoading);

    if (isLoading) {
      $wrap.attr('aria-busy', 'true');
    } else {
      $wrap.removeAttr('aria-busy');
    }

    $wrap.find('.cart-drawer__qty-btn').prop('disabled', !!isLoading);
    $input.prop('disabled', !!isLoading);
  }

  function commitCartDrawerQty($input) {
    if (!window.CartJS || !CartJS.cart || !CartJS.cart.items) {
      return;
    }

    if ($input.closest('.cart-drawer__qty').hasClass('is-loading')) {
      return;
    }

    if ($('#CartDrawer').hasClass('is-updating')) {
      return;
    }

    var line = parseInt($input.data('cart-qty-input'), 10);
    var item = line ? CartJS.cart.items[line - 1] : null;

    if (!item) {
      return;
    }

    var previousQty = item.quantity;
    var newQty = normalizeCartDrawerQty($input.val());

    $input.val(newQty);

    if (newQty === previousQty) {
      return;
    }

    setLineQuantity(line, newQty, $input, previousQty);
  }

  function setLineQuantity(line, newQty, $input, previousQty) {
    if (!window.CartJS || !CartJS.cart || !CartJS.cart.items) {
      return;
    }

    var item = CartJS.cart.items[line - 1];
    if (!item) {
      return;
    }

    if (typeof previousQty === 'undefined') {
      previousQty = item.quantity;
    }

    newQty = normalizeCartDrawerQty(newQty);

    if (newQty === previousQty) {
      if ($input && $input.length) {
        $input.val(previousQty);
      }
      return;
    }

    if ($input && $input.length && $input.closest('.cart-drawer__qty').hasClass('is-loading')) {
      return;
    }

    if (!theme.CartHelpers) {
      CartJS.updateItem(line, newQty);
      return;
    }

    setQtyLoading($input, true);

    Promise.resolve(
      theme.CartHelpers.applyLineQuantityWithInventoryCheck(line, newQty, $input, previousQty)
    ).catch(function(errorBody) {
      if ($input && $input.length) {
        $input.val(previousQty);
      }
      var errormsg = (errorBody && errorBody.description) ? errorBody.description : 'Unable to update cart.';
      theme.CartHelpers.showCartError(errormsg);
    }).finally(function() {
      setQtyLoading($input, false);
    });
  }

  function updateLineQuantity(line, delta) {
    if (!window.CartJS || !CartJS.cart || !CartJS.cart.items) {
      return;
    }

    var $input = $(selectors.drawer + ' .cart-drawer__qty-input[data-cart-qty-input="' + line + '"]');

    if ($input.closest('.cart-drawer__qty').hasClass('is-loading')) {
      return;
    }

    var item = CartJS.cart.items[line - 1];
    if (!item) {
      return;
    }

    var newQty = item.quantity + delta;
    if (newQty < 1) {
      newQty = 1;
    }

    setLineQuantity(line, newQty, $input, item.quantity);
  }

  function bindRemoveControls() {
    document.addEventListener('click', function(evt) {
      var btn = evt.target.closest('#CartDrawer .cart-drawer__remove');
      if (!btn || !theme.CartHelpers) {
        return;
      }

      evt.preventDefault();
      evt.stopPropagation();
      evt.stopImmediatePropagation();

      if (btn.disabled) {
        return;
      }

      var itemKey = theme.CartHelpers.resolveCartItemKey($(btn));
      if (!itemKey) {
        return;
      }

      btn.disabled = true;

      theme.CartHelpers.removeItemByKey(itemKey).finally(function() {
        btn.disabled = false;
      });
    }, true);
  }

  function bindRecommendationAdds() {
    $(document).on('click', selectors.recommendationsList + ' .cart-drawer__recommendation-add', function(evt) {
      evt.preventDefault();
      evt.stopPropagation();

      var $btn = $(this);
      var variantId = $btn.data('variant-id');

      if (!variantId || !theme.CartHelpers || $btn.prop('disabled') || $btn.hasClass('is-loading') || $('#CartDrawer').hasClass('is-updating')) {
        return;
      }

      $btn.prop('disabled', true).addClass('is-loading').attr('aria-busy', 'true');

      theme.CartHelpers.fetchCartAdd(variantId, 1, {
        skipSellingPlan: true,
        skipRecommendations: true
      })
        .then(function(cart) {
          theme.CartHelpers.applyCartState(cart, { openDrawer: false });
        })
        .catch(function(errorBody) {
          var errormsg = (errorBody && errorBody.description) ? errorBody.description : 'Unable to add item to cart.';
          theme.CartHelpers.showCartError(errormsg);
        })
        .finally(function() {
          $btn.prop('disabled', false).removeClass('is-loading').removeAttr('aria-busy');
        });
    });
  }

  function destroyRecommendationsSlider() {
    var $list = $(selectors.recommendationsList);
    if ($list.length && $list.hasClass('slick-initialized')) {
      $list.slick('unslick');
    }
  }

  function initRecommendationsSlider() {
    var $wrap = $(selectors.recommendations);
    var $list = $(selectors.recommendationsList);

    if (!$wrap.length || !$list.length || $wrap.is('[hidden]') || !$list.children().length) {
      return;
    }

    if (typeof $.fn.slick !== 'function') {
      return;
    }

    destroyRecommendationsSlider();

    $list.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      dots: false,
      speed: 400,
      cssEase: 'ease',
      prevArrow: $wrap.find(selectors.recommendationsPrev),
      nextArrow: $wrap.find(selectors.recommendationsNext),
      rtl: theme.rtl,
      touchMove: true,
      draggable: true
    });

    $list.slick('setPosition');
  }

  function refreshRecommendationsSlider() {
    var $list = $(selectors.recommendationsList);

    if ($list.length && $list.hasClass('slick-initialized')) {
      $list.slick('setPosition');
      return;
    }

    initRecommendationsSlider();
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function getRecommendationImageSrc(product) {
    var image = product.featured_image;

    if (typeof image === 'string' && image) {
      return image;
    }

    if (typeof image === 'object' && image !== null && image.src) {
      return image.src;
    }

    if (product.images && product.images.length) {
      var firstImage = product.images[0];
      if (typeof firstImage === 'string') {
        return firstImage;
      }
      if (firstImage && firstImage.src) {
        return firstImage.src;
      }
    }

    if (product.image) {
      if (typeof product.image === 'string') {
        return product.image;
      }
      if (product.image.src) {
        return product.image.src;
      }
    }

    return '';
  }

  function getRecommendationImageUrl(src) {
    if (!src) {
      return '';
    }

    if (theme.Images && theme.Images.getSizedImageUrl) {
      return theme.Images.getSizedImageUrl(src, '240x240') || src;
    }

    return src;
  }

  function renderRecommendations(products) {
    var $wrap = $(selectors.recommendations);
    var $list = $(selectors.recommendationsList);

    if (!$wrap.length || !$list.length) {
      return;
    }

    if (!products || !products.length) {
      cachedRecommendationProducts = [];
      destroyRecommendationsSlider();
      $wrap.attr('hidden', true);
      $list.empty();
      return;
    }

    cachedRecommendationProducts = products;

    var html = '';
    $.each(products, function(index, product) {
      var variant = product.variants && product.variants.length ? product.variants[0] : null;
      if (!variant || !variant.available) {
        return;
      }

      var imageSrc = getRecommendationImageSrc(product);
      if (!imageSrc) {
        return;
      }

      var image = getRecommendationImageUrl(imageSrc);
      var loadingMode = index < 3 ? 'eager' : 'lazy';

      html += '<div class="cart-drawer__recommendation-wrap">';
      html += '<a class="cart-drawer__recommendation" href="' + product.url + '">';
      html += '<img class="cart-drawer__recommendation-image" src="' + image + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="' + loadingMode + '" decoding="async" width="120" height="120">';
      html += '<p class="cart-drawer__recommendation-title">' + product.title + '</p>';
      html += '<p class="cart-drawer__recommendation-price">' + formatMoney(variant.price) + '</p>';
      html += '</a>';
      html += '<button type="button" class="btn btn--secondary btn--small cart-drawer__recommendation-add" data-variant-id="' + variant.id + '">';
      html += '<span class="cart-drawer__recommendation-add__label">' + theme.strings.addToCart + '</span>';
      html += '<span class="cart-drawer__recommendation-add__loader" aria-hidden="true"></span>';
      html += '</button>';
      html += '</div>';
    });

    if (!html) {
      cachedRecommendationProducts = [];
      destroyRecommendationsSlider();
      $wrap.attr('hidden', true);
      $list.empty();
      return;
    }

    destroyRecommendationsSlider();
    $list.html(html);
    $wrap.removeAttr('hidden');

    requestAnimationFrame(function() {
      initRecommendationsSlider();
    });
  }

  function getCartProductIds(cart) {
    var ids = [];
    if (!cart || !cart.items) {
      return ids;
    }

    $.each(cart.items, function(_, item) {
      if (item.product_id) {
        ids.push(item.product_id);
      }
    });

    return ids;
  }

  function loadRecommendations(cart) {
    var $drawer = $(selectors.drawer);
    if ($drawer.data('show-recommendations') === false || $drawer.data('show-recommendations') === 'false') {
      return;
    }

    cart = cart || (window.CartJS ? CartJS.cart : null);
    var limit = parseInt($drawer.data('recommendations-limit'), 10) || 4;
    var cartProductIds = getCartProductIds(cart);
    var requestKey = cartProductIds.join(',') + '|' + limit;

    if (requestKey === lastRecommendationKey) {
      if (cachedRecommendationProducts.length) {
        renderRecommendations(cachedRecommendationProducts);
      }
      return;
    }

    lastRecommendationKey = requestKey;

    if (recommendationsRequest) {
      recommendationsRequest.abort();
    }

    if (!cart || cart.item_count < 1) {
      loadFallbackRecommendations(limit, []);
      return;
    }

    var productId = cart.items[0].product_id;
    recommendationsRequest = $.getJSON('/recommendations/products.json', {
      product_id: productId,
      limit: limit + cartProductIds.length,
      intent: 'related'
    }).done(function(data) {
      var products = (data.products || []).filter(function(product) {
        return cartProductIds.indexOf(product.id) === -1;
      }).slice(0, limit);

      cachePrefetchedProducts(productId, data.products || []);

      if (products.length) {
        renderRecommendations(products);
      } else {
        loadFallbackRecommendations(limit, cartProductIds);
      }
    }).fail(function() {
      loadFallbackRecommendations(limit, cartProductIds);
    });
  }

  function loadFallbackRecommendations(limit, excludeIds) {
    var $drawer = $(selectors.drawer);
    var collectionHandle = $drawer.data('fallback-collection');

    if (!collectionHandle) {
      renderRecommendations([]);
      return;
    }

    recommendationsRequest = $.getJSON('/collections/' + collectionHandle + '/products.json', {
      limit: limit + (excludeIds ? excludeIds.length : 0)
    }).done(function(data) {
      var products = (data.products || []).filter(function(product) {
        return !excludeIds || excludeIds.indexOf(product.id) === -1;
      }).slice(0, limit);

      if (!cachedFallbackProducts.length) {
        cachedFallbackProducts = data.products || [];
      }

      renderRecommendations(products);
    }).fail(function() {
      renderRecommendations([]);
    });
  }

  return {
    init: init,
    initCheckoutAgreement: initCheckoutAgreement,
    open: open,
    close: close,
    refresh: refresh,
    scheduleRefreshAfterOpen: scheduleRefreshAfterOpen,
    loadRecommendations: loadRecommendations,
    prefetchForProduct: prefetchForProduct,
    showInstantRecommendations: showInstantRecommendations
  };
})();

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };
	
  $(window).on('load delayed-resize', function (e, resizeEvent) {
  	var SlideshowHeight = $(window).height();
    if($(window).width() < '992' ){
      $(".slideshow-wrapper .slideshow--fullScreen").height(SlideshowHeight-100);
    } else {
      $(".slideshow-wrapper .slideshow--fullScreen").height(SlideshowHeight);
    }
  });
  
  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);

    this.settings = {
      accessibility: true,
      arrows: true,
      dots: false,
      rtl: theme.rtl,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed')
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function(evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if ((evt.which === 37) || (evt.which === 39)) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video);
      var currentVideoId = $currentVideo.attr('id');
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr('tabindex', '-1');
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video);
      var videoId = $video.attr('id');
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr('tabindex', '0');
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length;
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function() {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    slideshowWrapper: 'slideshow-wrapper',
    slide: 'slideshow__slide',
    slideBackgroundVideo: 'slideshow__slide--background-video',
    slideDots: 'slick-dots',
    videoChrome: 'slideshow__video--chrome',
    videoBackground: 'slideshow__video--background',
    playVideoBtn: 'slideshow__video-control--play',
    closeVideoBtn: 'slideshow__video-control--close',
    currentSlide: 'slick-current',
    slickClone: 'slick-cloned',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay'
  };

  /**
    * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
      videoSelector: $video.attr('id'),
      $parentSlide: $video.closest('.' + classes.slide),
      $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
      controls: $video.data('type') === 'background' ? 0 : 1,
      slideshow: $video.data('slideshow')
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo === 'function') {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
    * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
      .then(function() {
        setAutoplaySupport(true);
      })
      .fail(function() {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false);
        player.stopVideo();
      })
      .always(function() {
        autoplayCheckComplete = true;
        $slide.removeClass(classes.loading);
      });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 750) {
      playOnClick = true;
    } else if (window.mobileCheck()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case 'background-chrome':
      case 'background':
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'background-chrome':
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case 'chrome':
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    $('#' + videoData.id).attr('tabindex', '0');

    switch (videoData.type) {
      case 'chrome':
      case 'background-chrome':
        $slideshow
          .removeClass(classes.paused)
          .addClass(classes.playing);
        $slide
          .removeClass(classes.paused)
          .addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find('.' + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === 'background-chrome') {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== 'closed' && videoData.type !== 'background') {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === 'chrome' && videoData.status === 'closed') {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(' ');

    $('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'background-chrome':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case 'chrome':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = 'open';

    switch (videoData.type) {
      case 'background-chrome':
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case 'chrome':
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    $(document).on('keydown.videoPlayer', function(evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $('.' + classes.videoBackground).each(function(index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest('.' + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player.width(playerWidth).height(playerHeight).css({
        left: (slideWidth - playerWidth) / 2,
        top: 0
      }); // player width is greater, offset left; reset top
    } else { // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player.width(slideWidth).height(playerHeight).css({
        left: 0,
        top: (playerHeight - playerHeight) / 2
      }); // player height is greater, offset top; reset left
    }

    $player
      .prepareTransition()
      .addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $('#' + playerId)
      .removeAttr('style')
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].$parentSlide
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $('#' + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide
      .addClass(classes.slideBackgroundVideo);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');
      startVideoOnClick(playerId);
    });

    $(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');
      closeVideo(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on('resize.videoPlayer', $.debounce(250, function() {
      if (youtubeLoaded) {
        sizeBackgroundVideos();
      }
    }));
  }

  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();


/* ================ TEMPLATES ================ */
(function() {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function() {
    location.href = $(this).val();
  });

})();

window.theme = theme || {};

theme.customerTemplates = (function() {

  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();




/*================ SECTIONS ================*/

// Navigation Menu
window.theme = window.theme || {};

theme.navigationmenu = (function() {

	var selectors = {
      	body: 'body',
      	sitenav: '#siteNav',
      	navLinks: '#siteNav .lvl1 > a',
      	menuToggle: '.js-mobile-nav-toggle',
      	mobilenav: '.mobile-nav-wrapper',
      	menuLinks: '#MobileNav .plus',
      	closemenu: '.closemobileMenu'
	};
     
  	$(selectors.navLinks).each(function(){
        if($(this).attr('href') == window.location.pathname) $(this).addClass('active');
    })

  	$(selectors.menuToggle).on("click",function(){
      body: 'body',
      $(selectors.mobilenav).toggleClass("active");
      $(selectors.body).toggleClass("menuOn");
      $(selectors.menuToggle).toggleClass('mobile-nav--open mobile-nav--close');
    });
  
    $(selectors.closemenu).on("click",function(){
      body: 'body',
      $(selectors.mobilenav).toggleClass("active");
      $(selectors.body).toggleClass("menuOn");
      $(selectors.menuToggle).toggleClass('mobile-nav--open mobile-nav--close');
    });
  	
	$(selectors.menuLinks).on('click', function(e) {
		e.preventDefault();
		$(this).toggleClass('ad-plus-l ad-minus-l');
		$(this).parent().next().slideToggle();
    });

})();



window.theme = window.theme || {};

theme.Cart = (function() {
  var selectors = {
    edit: '.js-edit-toggle',
    qtyBtn: '.qtyBtn',
    qtyInput: '.cart__qty-input',
    cartRow: '.cart__row[data-line]'
  };
  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies'
  };

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);
    this.qtyTimers = {};
    this.syncingLines = {};

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }

    this.$edit.on('click', this._onEditClick.bind(this));
    this._initQuantityUpdates();
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function() {
      this.$edit.off('click', this._onEditClick);
      this.$container.off('.cartQty');
      $.each(this.qtyTimers, function(_, timer) {
        clearTimeout(timer);
      });
    },

    _onEditClick: function(evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));

      $evtTarget.toggleClass(config.showEditClass);
      $updateLine.toggleClass(config.showClass);
    },

    _initQuantityUpdates: function() {
      var self = this;

      this.$container.on('click.cartQty', selectors.qtyBtn, function(evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        var $qtyField = $(this).closest('.qtyField');
        var $input = $qtyField.find(selectors.qtyInput);
        var oldValue = parseInt($input.val(), 10) || 0;
        var newVal = oldValue;

        if ($(this).hasClass('plus')) {
          newVal = oldValue + 1;
        } else if (oldValue > 0) {
          newVal = oldValue - 1;
        }

        $input.val(newVal);
        self._updateLineQuantity($(this).closest(selectors.cartRow), newVal);
      });

      this.$container.on('change.cartQty', selectors.qtyInput, function() {
        var qty = parseInt($(this).val(), 10);
        if (isNaN(qty) || qty < 0) {
          qty = 0;
        }
        $(this).val(qty);
        self._updateLineQuantity($(this).closest(selectors.cartRow), qty);
      });
    },

    _updateLineQuantity: function($row, quantity) {
      var line = parseInt($row.data('line'), 10);
      var self = this;

      if (!line) {
        return;
      }

      clearTimeout(this.qtyTimers[line]);
      this.qtyTimers[line] = setTimeout(function() {
        var qty = parseInt($row.find(selectors.qtyInput).val(), 10);
        if (isNaN(qty) || qty < 0) {
          qty = 0;
        }
        self._syncLineQuantity($row, line, qty);
      }, 350);
    },

    _syncLineQuantity: function($row, line, qty) {
      var self = this;

      if (this.syncingLines[line]) {
        clearTimeout(this.qtyTimers[line]);
        this.qtyTimers[line] = setTimeout(function() {
          var latestQty = parseInt($row.find(selectors.qtyInput).val(), 10);
          if (isNaN(latestQty) || latestQty < 0) {
            latestQty = 0;
          }
          self._syncLineQuantity($row, line, latestQty);
        }, 100);
        return;
      }

      this.syncingLines[line] = true;

      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
          line: line,
          quantity: qty
        }
      })
      .done(function(cart) {
        Cart.updateHeaderCartCount(cart);

        if (!cart.item_count || qty === 0) {
          window.location.reload();
          return;
        }

        Cart.refreshCartPage(cart);

        var currentQty = parseInt($row.find(selectors.qtyInput).val(), 10) || 0;
        if (currentQty !== qty) {
          self._updateLineQuantity($row, currentQty);
        }
      })
      .fail(function() {
        window.location.reload();
      })
      .always(function() {
        self.syncingLines[line] = false;
      });
    },

    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled){
        document.cookie = 'testcookie';
        cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
      }
      return cookieEnabled;
    }
  });

  Cart.refreshCartPage = function(cart) {
    var formatMoney = theme.Currency.formatMoney;
    var moneyFormat = theme.moneyFormat;

    $.each(cart.items, function(index, item) {
      var line = index + 1;
      var $row = $('.cart__row[data-line="' + line + '"]');

      if (!$row.length) {
        return;
      }

      $row.find('.cart__line-price').html(formatMoney(item.line_price, moneyFormat));
      $row.find('.cart__unit-price').html(formatMoney(item.price, moneyFormat));
      $row.find('.cart__qty-input').each(function() {
        if (!$(this).is(':focus')) {
          $(this).val(item.quantity);
        }
      });

      var $mobileQty = $row.find('.cart__mobile-qty');
      if (item.quantity > 1) {
        $mobileQty.removeClass('hide').find('.cart__mobile-qty-count').text(item.quantity);
      } else {
        $mobileQty.addClass('hide').find('.cart__mobile-qty-count').text(item.quantity);
      }

      if (item.original_line_price > item.line_price) {
        $row.find('.cart-item__original-price').removeClass('hide');
        $row.find('.cart__original-line-price').html(formatMoney(item.original_line_price, moneyFormat));
      } else {
        $row.find('.cart-item__original-price').addClass('hide');
      }
    });

    $('[data-cart-subtotal], .cart__subtotal').html(formatMoney(cart.total_price, moneyFormat));

    if (cart.total_discounts > 0) {
      $('.cart__savings').removeClass('hide');
      $('[data-cart-savings], .cart__savings-amount').html(formatMoney(cart.total_discounts, moneyFormat));
    } else {
      $('.cart__savings').addClass('hide');
    }

    if (typeof Currency !== 'undefined' && $('#currencies li.selected').length) {
      Currency.convertAll(shopCurrency, $('#currencies li.selected').attr('data-currency'));
    }

    Cart.updateHeaderCartCount(cart);
  };

  Cart.updateHeaderCartCount = function(cart, options) {
    options = options || {};

    if (!cart) {
      return;
    }

    if (window.CartJS && CartJS.cart) {
      if (typeof CartJS.cart.update === 'function') {
        CartJS.cart.update(cart);
        if (theme.CartHelpers && theme.CartHelpers.enrichCartSubscriptionLabels) {
          theme.CartHelpers.enrichCartSubscriptionLabels(CartJS.cart);
        }
        if (!options.skipRender) {
          CartJS.render({}, CartJS.cart);
        }
      } else {
        CartJS.cart = cart;
        if (theme.CartHelpers && theme.CartHelpers.enrichCartSubscriptionLabels) {
          theme.CartHelpers.enrichCartSubscriptionLabels(CartJS.cart);
        }
        if (!options.skipRender) {
          CartJS.render({}, cart);
        }
      }
    }

    $('[data-cart-render="item_count"], .site-header__cart-count').text(cart.item_count);

    if (options.skipRender && theme.CartHelpers && theme.CartHelpers.updateCartDrawerTotals) {
      theme.CartHelpers.updateCartDrawerTotals(cart);
    }
  };

  Cart.syncFromServer = function() {
    return $.getJSON('/cart.js').done(function(cart) {
      Cart.updateHeaderCartCount(cart);
      $(document).trigger('cart.synced', [cart]);
    });
  };

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function() {
  var constants = {
    SORT_BY: 'sort_by'
  };
  var selectors = {
    filterSelection: '.filters-toolbar__input--filter',
    sortSelection: '.filters-toolbar__input--sort',
    defaultSort: '.collection-header__default-sort'
  };

  function Filters(container) {
    var $container = this.$container = $(container);

    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add($(selectors.sortSelection, $container));

    this.defaultSort = this._getDefaultSortValue();
    this._resizeSelect(this.$selects);
    this.$selects.removeClass('hidden');

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
    
    // SHOW HIDE PRODUCT Filters
  	$("body").click(function(event){
    	var $target = $(event.target);
    	if(!$target.parents().is(".filterbar") && !$target.is(".filterbar") && !$target.is(".filterBtn")){
      		$(".filterbar").removeClass("active");
    	}
	});
	$('.btn-filter').click(function(event){
      	event.stopPropagation();
    	$(".filterbar").toggleClass("active");
	});
	$('.closeFilter').click(function(){
		$(".filterbar").removeClass("active");
	});
    
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _onSortChange: function(evt) {
      var sort = this._getSortValue();
      var url = new URL(window.location.href);

      if (sort !== this.defaultSort) {
        url.searchParams.set(constants.SORT_BY, sort);
      } else {
        url.searchParams.delete(constants.SORT_BY);
      }

      var newUrl = url.pathname + url.search;

      if (typeof window.ajaxfilter === 'function' && document.querySelector('.plp-facets')) {
        window.ajaxfilter(newUrl);
      } else {
        window.location.href = newUrl;
      }

      this._resizeSelect($(evt.target));
    },

    _onFilterChange: function(evt) {
      window.location.href = this.$filterSelect.val() + window.location.search;
      this._resizeSelect($(evt.target));
    },

    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return $(selectors.defaultSort, this.$container).val();
    },

    _sortValue: function() {
      var sort = this._getSortValue();
      var query = '';

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort;
      }

      return query;
    },
	
    _resizeSelect: function($selection) {
      $selection.each(function() {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function() {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {

  function Header() {
    theme.Header.init();
   // theme.MobileNav.init();
    theme.Search.init();
    theme.CartDrawer.init();
    if (theme.CartDrawer.initCheckoutAgreement) {
      theme.CartDrawer.initCheckoutAgreement();
    }
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
    }
  });

  return Header;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];
  var key = theme.mapKey ? theme.mapKey : '';

  function Map(container) {
    this.$container = $(container);

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key)
            .then(function() {
              apiStatus = 'loaded';
              initAllMaps();
            });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({address: address}, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
        .then(function(results) {
          var mapOptions = {
            zoom: config.zoom,
            center: results[0].geometry.location,
            disableDefaultUI: true
          };

          var map = this.map = new google.maps.Map($map[0], mapOptions);
          var center = this.center = map.getCenter();

          //eslint-disable-next-line no-unused-vars
          var marker = new google.maps.Marker({
            map: map,
            position: map.getCenter()
          });

          google.maps.event.addDomListener(window, 'resize', $.debounce(250, function() {
            google.maps.event.trigger(map, 'resize');
            map.setCenter(center);
          }));
        }.bind(this))
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }

          $map
            .parent()
            .addClass('page-width map-section--load-error')
            .html('<div class="errors text-center">' + errorMessage + '</div>');
        });
    },

    onUnload: function() {
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  $('.map-section').addClass('map-section--load-error');
  $('.map-section__container').remove();
  $('.map-section__link').remove();
  $('.map-section__overlay').after('<div class="errors text-center">' + theme.strings.authError + '</div>');
}

/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var galleryThumbnailPosition = $container.attr('thumbnail-position');
  
    // RELATED PRODUCT SLIDER     
    var sliderRelatedAnimationSpeed = $container.attr('proRelated-aniamtion');     
    var sliderRelatedToShow= $container.attr('proRelated-num');   
    var sliderRelatedAutoSpeed= $container.attr('proRelated-timeout');  
    var sliderRelatedAuto=$container.attr('proRelated-autoplay');
    
    
      // Orders Message
    var orderLimit = $(".orderMsg").attr('data-user'),
        orderTime = $(".orderMsg").attr('data-time');
    $(".orderMsg .items").text(Math.floor((Math.random() * orderLimit) + 1));
    $(".orderMsg .time").text(Math.floor((Math.random() * orderTime) + 5));
    
    // Visotore Message
    var userLimit = $(".userViewMsg").attr('data-user'),
        userTime = $(".userViewMsg").attr('data-time');
    $(".uersView").text(Math.floor((Math.random() * userLimit) + 10));
    setInterval(function(){
    	$(".uersView").text(Math.floor((Math.random() * userLimit) + 10));
	}, userTime);
    
    
    var tabs = this.tabs = '#ProductSection-' + sectionId + ' .tablink';
    var $productSection = $('#ProductSection-' + sectionId);
    var accordionSpeed = 300;

    $productSection.find('.product-tabs li:first-child').addClass('active');

    function initProductAccordion() {
      var $accordion = $productSection.find('.accordion-style');
      if (!$accordion.length) {
        return;
      }

      var $headers = $accordion.find('.acor-ttl');
      var $panels = $accordion.find('.tab-content');
      var $firstHeader = $headers.first();
      var $firstPanel = $panels.first();

      $panels.hide().removeClass('is-open');
      $headers.removeClass('active');

      if ($firstHeader.length) {
        $firstHeader.addClass('active');
        $firstPanel.show().addClass('is-open');
      }
    }

    function closeAccordionPanel($header, $panel, callback) {
      if (!$panel.length || !$panel.is(':visible') || $panel.is(':animated')) {
        if (typeof callback === 'function') {
          callback();
        }
        return;
      }

      $header.removeClass('active');
      $panel.slideUp(accordionSpeed, function() {
        $panel.removeClass('is-open');
        if (typeof callback === 'function') {
          callback();
        }
      });
    }

    function openAccordionPanel($header, $panel, callback) {
      if (!$panel.length || $panel.is(':visible') || $panel.is(':animated')) {
        if ($panel.length) {
          $header.addClass('active');
          $panel.addClass('is-open');
        }
        if (typeof callback === 'function') {
          callback();
        }
        return;
      }

      $header.addClass('active');
      $panel.slideDown(accordionSpeed, function() {
        $panel.addClass('is-open');
        if (typeof callback === 'function') {
          callback();
        }
      });
    }

    initProductAccordion();

    $(tabs).on('click', function(e){
      e.preventDefault();
      var $trigger = $(this);
      var $parent = $trigger.parent();
      var $accordionWrap = $trigger.closest('.accordion-style');
      var tab = $trigger.attr('href');
      var $panel = $productSection.find(tab);
      var $header = $parent.hasClass('acor-ttl') ? $parent : $();

      if ($accordionWrap.length) {
        var $headers = $accordionWrap.find('.acor-ttl');

        if ($header.hasClass('active')) {
          closeAccordionPanel($header, $panel);
          return;
        }

        $headers.not($header).each(function() {
          var $otherHeader = $(this);
          var $otherPanel = $productSection.find($otherHeader.find('.tablink').attr('href'));
          closeAccordionPanel($otherHeader, $otherPanel);
        });

        openAccordionPanel($header, $panel);
        return;
      }

      $parent.addClass('active');
      $parent.siblings().removeClass('active');
      $productSection.find('.tab-content').not(tab).css('display', 'none');
      $productSection.find(tab).fadeIn(accordionSpeed);

      if ($(window).width() < 767) {
        var tabposition = $trigger.offset();
        $('html, body').animate({ scrollTop: tabposition.top }, 700);
      }
    });
    
    $('.reviewLink').on('click', function(e){
      e.preventDefault();
      var tab = $(this).attr('href');
      var $accordionWrap = $productSection.find('.accordion-style');

      $('.product-tabs li').removeClass('active');
      $('.reviewtab').addClass('active');

      if ($accordionWrap.length) {
        var $reviewHeader = $accordionWrap.find('.acor-ttl.reviewtab');
        var $reviewPanel = $productSection.find(tab);

        $accordionWrap.find('.acor-ttl').not($reviewHeader).each(function() {
          var $otherHeader = $(this);
          var $otherPanel = $productSection.find($otherHeader.find('.tablink').attr('href'));
          closeAccordionPanel($otherHeader, $otherPanel);
        });

        openAccordionPanel($reviewHeader, $reviewPanel);
      } else {
        $productSection.find('.tab-content').not(tab).css('display', 'none');
        $productSection.find(tab).fadeIn(accordionSpeed);
      }

      var tabposition = $productSection.find('#tab2').offset();
      if ($(window).width() < 767) {
        $('html, body').animate({ scrollTop: tabposition.top - 50 }, 700);
      } else {
        $('html, body').animate({ scrollTop: tabposition.top - 80 }, 700);
      }
    });
    
    $('.sizelink').magnificPopup({
  		type:'inline',
  		midClick: true
	});
            
    $('.related-product .grid-products').slick({
      dots: false,
      infinite: true,     
      slidesToShow:sliderRelatedToShow,
      autoplaySpeed: sliderRelatedAutoSpeed,
      speed:sliderRelatedAnimationSpeed,    
      slidesToScroll: 1,
      rtl: theme.rtl,
	  autoplay: sliderRelatedAuto, 
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },        
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    // End Slider
    
    
    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      imageSize: null,
      imageZoomSize: null,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false,
      galleryposition : galleryThumbnailPosition
    };

    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      originalPrice: '#ProductPrice-' + sectionId,
      SKU: '.variant-sku',
      originalPriceWrapper: '.product-price__price-' + sectionId,
      originalSelectorId: '#ProductSelect-' + sectionId,
      productFeaturedImage: '#FeaturedImage-' + sectionId,
      productImageWrap: '#FeaturedImageZoom-' + sectionId,
      productPrices: '.product-single__price-' + sectionId,
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      saleClasses: 'product-price__sale product-price__sale--single',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      stickyBar: '#StickyAddToCart-' + sectionId,
      stickyAddToCart: '#StickyAddToCartBtn-' + sectionId,
      stickyAddToCartText: '#StickyAddToCartText-' + sectionId,
      stickyPrice: '#StickyProductPrice-' + sectionId,
      stickyVariantTitle: '#StickyVariantTitle-' + sectionId,
      stickyProductImage: '#StickyProductImage-' + sectionId
    }

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);

    if (theme.CartDrawer && typeof theme.CartDrawer.prefetchForProduct === 'function') {
      theme.CartDrawer.prefetchForProduct(this.productSingleObject.id);
    }

    this.settings.zoomEnabled = $(this.selectors.productFeaturedImage).hasClass('js-zoom-enabled');
    this.settings.imageSize = theme.Images.imageSize($(this.selectors.productFeaturedImage).attr('src'));

    if (this.settings.zoomEnabled) {
      this.settings.imageZoomSize = theme.Images.imageSize($(this.selectors.productImageWrap).data('zoom'));
    }

    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._setActiveThumbnail();
    this._initThumbnailSlider();
    this._initStickyAddToCart();

    // Pre-loading product images to avoid a lag when a thumbnail is clicked, or
    // when a variant is selected that has a variant image
    theme.Images.preload(this.productSingleObject.images, this.settings.imageSize);
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            _destroyZoom($(self.selectors.productImageWrap));
          }

          self.settings.bpSmall = true;
        },
        unmatch: function() {
          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.zoomEnabled) {
            _enableZoom($(self.selectors.productImageWrap));
          }
        }
      });
    },

    _initVariants: function(){
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on('variantChange' + this.settings.namespace, this._updateAddToCart.bind(this));
      this.$container.on('variantImageChange' + this.settings.namespace, this._updateImages.bind(this));
      this.$container.on('variantPriceChange' + this.settings.namespace, this._updatePrice.bind(this));
      this.$container.on('variantSKUChange' + this.settings.namespace, this._updateSKU.bind(this));
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages).on('click', function(evt) {
        evt.preventDefault();
        var $el = $(this);
        var imageSrc = $el.attr('href');
        var zoomSrc = $el.data('zoom');

        self._switchImage(imageSrc, zoomSrc);
        self._setActiveThumbnail(imageSrc);
      });
    },

    _setActiveThumbnail: function(src) {
      var activeClass = 'active-thumb';

      // If there is no element passed, find it by the current product image
      if (typeof src === 'undefined') {
        src = $(this.selectors.productFeaturedImage).attr('src');
      }

      // Set active thumbnails (incl. slick cloned thumbs) with matching 'href'
      var $thumbnail = $(this.selectors.productThumbImages + '[href="' + src + '"]');
      $(this.selectors.productThumbImages).removeClass(activeClass);
      $thumbnail.addClass(activeClass);
    },

    _switchImage: function(image, zoomImage) {
      $(this.selectors.productFeaturedImage).attr('src', image);

      // destroy image zooming if enabled
      if (this.settings.zoomEnabled) {
        _destroyZoom($(this.selectors.productImageWrap));
      }

      if (!this.settings.bpSmall && this.settings.zoomEnabled && zoomImage) {
        $(this.selectors.productImageWrap).data('zoom', zoomImage);
        _enableZoom($(this.selectors.productImageWrap));
      }
    },

    _initThumbnailSlider: function() {   
           
      /// if horizontal thumbnail position      
      if(this.settings.galleryposition == 'true'){
         valboolean = false;
         heightTrue = false;
      } else {
        valboolean = true;
        heightTrue = true;
      }
      
      var options = {
        verticalSwiping: valboolean,
        vertical: valboolean,
        slidesToShow: 5,
        slidesToScroll: 1,
        rtl: theme.rtl,
        infinite: false,
        adaptiveHeight:heightTrue,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4,
              vertical: false,            
              verticalSwiping: false,
              swipe: true,
              draggable: false
            }
          }
        ]
      };

      $(this.selectors.productThumbs).slick(options);
      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;
    },

    _updateStickyBar: function(variant, state) {
      var $sticky = $(this.selectors.stickyBar);
      var $btn = $(this.selectors.stickyAddToCart);
      var $text = $(this.selectors.stickyAddToCartText);

      if (!$sticky.length || !$text.length) {
        return;
      }

      if (state === 'available' && variant) {
        $sticky.removeClass('is-sold-out');
        $btn.prop('disabled', false).attr('data-variant-id', variant.id);
        $text.html(
          '<span class="sticky-add-to-cart__label">' + theme.strings.addToCart.toUpperCase() + '</span>' +
          '<span class="sticky-add-to-cart__separator"> - </span>' +
          '<span id="StickyProductPrice-' + this.settings.sectionId + '" class="sticky-add-to-cart__btn-price">' +
            theme.Currency.formatMoney(variant.price, theme.moneyFormat) +
          '</span>'
        );
      } else if (state === 'soldOut') {
        $sticky.addClass('is-sold-out');
        $btn.prop('disabled', true).removeAttr('data-variant-id');
        $text.html('<span class="sticky-add-to-cart__label">' + theme.strings.soldOut.toUpperCase() + '</span>');
      } else {
        $sticky.addClass('is-sold-out');
        $btn.prop('disabled', true).removeAttr('data-variant-id');
        $text.html('<span class="sticky-add-to-cart__label">' + theme.strings.unavailable.toUpperCase() + '</span>');
      }
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.productPrices)
          .removeClass('visibility-hidden')
          .attr('aria-hidden', 'true');

        if (variant.available){
          $(this.selectors.addToCart).prop('disabled', false);
          $(this.selectors.addToCartText).text(theme.strings.addToCart);
          this._updateStickyBar(variant, 'available');
          $(".instock").removeClass("hide");
          $(".outstock").addClass("hide");
          var quantity = $("#pvr-"+variant.id).text();
          $("#quantity_message").show().find(".items").text(quantity);
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).text(theme.strings.soldOut);
          this._updateStickyBar(variant, 'soldOut');
          $(".instock").addClass("hide");
          $(".outstock").removeClass("hide");
          $("#quantity_message").hide();
        }

        if ($(this.selectors.stickyVariantTitle).length && variant.title) {
          $(this.selectors.stickyVariantTitle).text(variant.title);
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).text(theme.strings.unavailable);
        this._updateStickyBar(null, 'unavailable');
        $(this.selectors.productPrices).addClass('visibility-hidden').attr('aria-hidden', 'false');
        $(".instock").addClass("hide");
        $(".outstock").removeClass("hide");
        $("#quantity_message").hide();
      }
    },

    _updateImages: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
      var zoomSizedImgUrl;

      if (this.settings.zoomEnabled) {
        zoomSizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageZoomSize);
      }

      this._switchImage(sizedImgUrl, zoomSizedImgUrl);
      this._setActiveThumbnail(sizedImgUrl);

      if ($(this.selectors.stickyProductImage).length && variant.featured_image) {
        $(this.selectors.stickyProductImage).attr('src', theme.Images.getSizedImageUrl(variant.featured_image.src, '120x120'));
      }
    },

     _updatePrice: function(evt) {
      var variant = evt.variant;

      // Update the product price
      $(this.selectors.originalPrice).html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
      $(this.selectors.stickyPrice).html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
      
       if (variant.unit_price != undefined) {
         $(".unit-price").html(theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat));
         $(".base-unit").html(variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit);
         $(".price__unit").removeClass('hide');
       } else {
         $(".price__unit").addClass('hide');
       }
       
      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.comparePrice).html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat)).removeClass('hide');
        $(this.selectors.originalPriceWrapper).addClass(this.selectors.saleClasses);
        $(this.selectors.saleLabel).removeClass('hide');
        var price1 = variant.compare_at_price - variant.price,
        	price2 = price1 * 100,
        	salecount = price2/variant.compare_at_price;
        $(this.selectors.originalPriceWrapper).next('.save-label').removeClass('hide').find('span').text(+salecount.toFixed());

      } else {
        $(this.selectors.comparePrice).addClass('hide');
        $(this.selectors.saleLabel).addClass('hide');
        $(this.selectors.originalPriceWrapper).next('.save-label').addClass('hide');
        $(this.selectors.originalPriceWrapper).removeClass(this.selectors.saleClasses);
      }
    },

    _initStickyAddToCart: function() {
      var $sticky = $(this.selectors.stickyBar);
      var $productAction = this.$container.find('.product-purchase-block .product-action, .product-action').first();

      if (!$sticky.length || !$productAction.length) {
        return;
      }

      var toggleStickyBar = function(show) {
        $sticky.toggleClass('is-visible', show).attr('aria-hidden', show ? 'false' : 'true');
        $('body').toggleClass('has-sticky-atc', show);

        if (show) {
          document.documentElement.style.setProperty('--sticky-atc-height', $sticky.outerHeight() + 'px');
        }
      };

      var updateStickyBarOffset = function() {
        if ($sticky.hasClass('is-visible')) {
          document.documentElement.style.setProperty('--sticky-atc-height', $sticky.outerHeight() + 'px');
        }
      };

      $(window).on('resize.sticky-atc-' + this.settings.sectionId, updateStickyBarOffset);

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            toggleStickyBar(!entry.isIntersecting);
          });
        }, { threshold: 0 });

        observer.observe($productAction[0]);
        this.stickyObserver = observer;
      } else {
        $(window).on('scroll.sticky-atc-' + this.settings.sectionId, function() {
          var rect = $productAction[0].getBoundingClientRect();
          toggleStickyBar(rect.bottom < 0);
        });
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function() {
      if (this.stickyObserver) {
        this.stickyObserver.disconnect();
      }
      $(window).off('scroll.sticky-atc-' + this.settings.sectionId);
      $(window).off('resize.sticky-atc-' + this.settings.sectionId);
      $('body').removeClass('has-sticky-atc');
      this.$container.off(this.settings.namespace);
    }
  });

  function _isMobileViewport() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function _isIpad() {
    if (/iPad/.test(navigator.userAgent)) {
      return true;
    }

    return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  }

  function _shouldDisableProductZoom() {
    return _isMobileViewport();
  }

  function _enableZoom($el) {
    if (_shouldDisableProductZoom()) {
      _destroyZoom($el);
      return;
    }

    var zoomUrl = $el.data('zoom');
    $el.zoom({
      url: zoomUrl,
      touch: false
    });
  }

  function _destroyZoom($el) {
    $el.trigger('zoom.destroy');
  }

  return Product;
})();

// Product quick view
theme.QuickView = (function() {
  $( 'body' ).on( 'click', '.quick-view', function(e) {
    $.ajax({
      beforeSend : function (){
        $('body').addClass("loading");
       },
      url: $(this).attr('href'),
      success: function(data) {

        $.magnificPopup.open({
          items: {
            src: '<div class="quick-view-popup" id="content_quickview">' + data + '</div>',
            type: 'inline'
          },
          removalDelay:500,
          callbacks: {
            beforeOpen: function() {
              this.st.mainClass = 'mfp-move-horizontal';
            },
            open: function() {
				$(".product-photoslider").slick({
                  dots: false,
                  infinite: true,
                  rtl: theme.rtl,
                  speed: 300,
                  slidesToShow: 1,
                  slidesToScroll: 1
                });
            },
            close: function() {
              $( '#content_quickview' ).empty();
            }
          },
        });
      },
      complete: function() {
        $('body').removeClass("loading");
      }
    })
    //return false; //for good measure
    e.preventDefault();
    e.stopPropagation();
  });
})();

theme.Quotes = (function() {

    var config = {
      mediaQuerySmall: 'screen and (max-width: 749px)',
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      slideCount: 0
    };
  
  function Quotes(container) {
    var $container = this.$container = $(container),
    	sectionId = $container.attr('data-section-id'),
    	wrapper = this.wrapper = '.quotes-wrapper',
    	slider = this.slider = '#Quotes-' + sectionId,
    	$slider = $(slider, wrapper),
    	autoplay = $container.attr('data-section-autoplay'),
    	autoplayspeed = $container.attr('data-section-autoplay-speed'),
        slidesPlay = false;
    
    if(autoplay == "true"){
      slidesPlay = true;
    }
    
	var defaults = {
      accessibility: true,
      arrows: true,
      dots: false,
      autoplay: slidesPlay,
      rtl: theme.rtl,
      touchThreshold: 20,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      autoplaySpeed:autoplayspeed,
      speed:500
    };
    
    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $('.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Quotes;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    $('.slideshow__video', slideshow).each(function() {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
  onUnload: function() {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function(evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function() {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});

// CATEGORY SLIDER
theme.collectionView = (function() {
  function collectionView(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var sliderSecond = $container.attr('data-section-timeout');        
    
    
    $("#collection-slideshow").slick({
        dots: false,
        infinite: true,
        autoplay:true,
      	rtl: theme.rtl,
        autoplaySpeed:7000,
        speed:600,
        slidesToShow:1,
        slidesToScroll:1
    });
    // End Slider
    
    $("#sideProdSlider").slick({
        dots: false,
        infinite: true,
        autoplay:true,
      	rtl: theme.rtl,
        autoplaySpeed:7000,
        speed:600,
        slidesToShow:1,
        slidesToScroll:1
    });
    
    window.ajaxfilter = function(url) {
        $.ajax({
          type: 'GET',
          url: url,
          data: {},
          beforeSend:function(){
            $('body').addClass('loading hideOverly');
          },
          complete: function (data) {

            $('.productList').html($(".productList", data.responseText).html());
            $('.filters-toolbar__product-count').html($(".filters-toolbar__product-count", data.responseText).html());

            var $newFacets = $(".plp-facets", data.responseText);
            if ($newFacets.length) {
              $('.plp-facets').replaceWith($newFacets);
              if (window.PLPFacets && window.PLPFacets.refresh) {
                window.PLPFacets.refresh();
              }
              if (window.PLPFacets && window.PLPFacets.checkEmptyPriceFilterResults) {
                document.querySelectorAll('.plp-facets').forEach(function(root) {
                  window.PLPFacets.checkEmptyPriceFilterResults(root);
                });
              }
            }

            var $newSort = $('#SortBy', data.responseText);
            if ($newSort.length) {
              $('#SortBy').val($newSort.val());
            }

            $('.sidebar_tags').html($(".sidebar_tags", data.responseText).html());
            if (typeof check_filters === 'function') {
              check_filters();
            }

            $('.pagination').html($(".pagination", data.responseText).html());
            if(!$(".pagination", data.responseText).html()){
              $('.pagination').hide();
            } else {
              $('.pagination').show();
            }
            $('.infinitpaginOuter').html($(".infinitpaginOuter", data.responseText).html());
            if(!$(".infinitpaginOuter", data.responseText).html()){
              $('.infinitpagin').remove();
            }
            
            $('body').removeClass('loading hideOverly');
            
            $(theme.colorSwatches); $(theme.ajaxCart); infiniteScroll(); loadMoreBtn();

            if($(".spr-badge").length > 0) {
            	$.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
            }
            productGridView(sectionId);
            setTimeout(function(){ productGridView(sectionId); },1000);
			
            history.pushState({
              page: url
            }, url, url);
          }
        });
    };
    function getSearchParams(k){
      var p={};
      location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi,function(s,k,v){p[k]=v})
      return k?p[k]:p;
    }
    
    infiniteScroll = function(){
        $(window).on('scroll load delayed-resize', function(){
          var moreURL = $('.infinitpagin a').attr('href');
          if ($('.infinitpagin a.infinite').length){
            var bottom = $('.infinitpagin').offset();
            var docTop = ($(document).scrollTop() + $(window).height() - 50);
            if( docTop > bottom.top){
              $(window).off('scroll');
              loadMore(moreURL);
            }
          }
        });
    }
    loadMoreBtn = function() {
		$('.infinitpagin a.loadMore').click(function(e){
          	e.preventDefault();
          	var moreURL = $(this).attr('href');
			loadMore(moreURL);
        });
    }
    
    loadMore = function(moreURL) {
      if (moreURL.length){
        $.ajax({
          type: 'GET',
          dataType: 'html',
          url: moreURL,
          beforeSend:function(){
          	if ($('.infinitpaginOuter').attr('data-type') == "button" ){
            	$('body').addClass('loading hideOverly');
            } else {
              $('.infinitpagin a').show();
            }
          },
          complete: function (data) {
            if($('.productList .grid-products').length){
            	$('.productList .grid-products').append($(".productList .grid-products", data.responseText).html());
            } else {
              	$('.productList .list-view-items').append($(".productList .list-view-items", data.responseText).html());
            }
            if($(".infinitpagin", data.responseText).html()){
            	$('.infinitpagin').html($(".infinitpagin", data.responseText).html());
            } else {
            	$('.infinitpagin').remove();
            }
            $(theme.ajaxCart);
            $(theme.colorSwatches);
            productGridView(sectionId);
			if($(".spr-badge").length > 0) {
                  $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
            }
            setTimeout(function(){ productGridView(sectionId); },1000);
            if ($('.infinitpagin a.loadMore').length){
            	loadMoreBtn();
            } else {
              infiniteScroll();
            }
            $('body').removeClass('loading hideOverly');
            scrollpage();
          }
        });
      }
    }
    
    $(window).load(function(){
      infiniteScroll();loadMoreBtn();
    });
    
	$(window).on('load delayed-resize', function (e, resizeEvent) {
  		productGridView(sectionId);
    });
  }
  
  return collectionView;
})();


/// collection prodct slider
theme.productSlider = {};

theme.prodcarouselSection = (function() {
  function prodcarouselSection(container) {
    var $container = this.$container = $(container);    
    var sectionId = $container.attr('data-section-id');
    var productSlider = this.productSlider = '#' + sectionId + ' .productSlider';
     var productitems = $container.attr('data-ds'),
        productitemsTb = $container.attr('data-tb'),
        productitemsMb = $container.attr('data-mb'),
        tabs = this.tabs = '#' + sectionId + ' .tablink',
    	tabcontent = this.tabcontent = '#' + sectionId + ' .tab-content',
        productRowSlider = this.productRowSlider = '#products-' + sectionId + ' .productSlider';
    
    $(tabs).on('click', function (e) {
        e.preventDefault();
        $(this).parent().addClass("active");
        $(this).parent().siblings().removeClass("active");
        var tab = $(this).attr("href");
        $(tabcontent).not(tab).css("display", "none");
        $(tab).fadeIn();
      	prodslider(tab+' .productSlider')
    });
    $('#' + sectionId).each(function(){
		$(this).find('.collection-tabs li:first-child').addClass("active");
		$(this).find('.tab-container h3:first-child + .tab-content').show();
		var firsttab = $(this).find('.collection-tabs li:first-child a').attr("href");
		prodslider(firsttab+' .productSlider');
    });
	
    if(productRowSlider.length) {
      	prodslider(productRowSlider);
    }
    
    function prodslider($slider) {
    
        $($slider).slick({
          dots: false,
          infinite: true,
          speed: 300,
          rtl: theme.rtl,
          centerPadding: 20,
          slidesToShow: productitems,
          slidesToScroll: 1,
          responsive: [                      
            {
              breakpoint: 999,
              settings: {
                slidesToShow: productitemsTb,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: productitemsMb,
                slidesToScroll: 1
              }
            }
          ]
        });
      $($slider).resize();
	}
   
    $(window).on('load delayed-resize', function (e, resizeEvent) {
  		productGridView(sectionId);
    });
  }

  return prodcarouselSection;
})();


theme.masonary = (function(){
    function masonary(container){
    	var $container = this.$container = $(container),
          sectionId = $container.attr('data-section-id'),
          masonary = this.masonary = $($container).find('.grid-masonary');
    
      loadMasonary(masonary);
      setTimeout( function(){ loadMasonary(masonary); },1000);
      function loadMasonary(masonary) {
        $(masonary).masonry({
            columnWidth: '.grid-sizer-'+sectionId,
            itemSelector: '.ms-item',
            percentPosition: true
        });
      }
  }
  return masonary;
})();



function productGridView(sectionId) {
  //alert(sectionId);
  var gridRows = []; 
  var tempRow = [];

  productGridElements = $('#'+sectionId+' .grid-products .grid__item');
  productGridElements.each(function (index) {
    if ($(this).css('clear') != 'none' && index != 0) {
      gridRows.push(tempRow);
      tempRow = []; 
    }
    tempRow.push(this);

    if (productGridElements.length == index + 1) {
      gridRows.push(tempRow);
    }
  });

  $.each(gridRows, function () {
    var tallestHeight = 0;
    var tallestHeight1 = 0;
    $.each(this, function () {
      $(this).find('.grid-view_image a.grid-view-item__link').css('height', '');

      elHeight = parseInt($(this).find('.grid-view_image').css('height'));

      if (elHeight > tallestHeight) { tallestHeight = elHeight; }
    });

    $.each(this, function () {
    	$(this).find('.grid-view_image > a.grid-view-item__link').css('height', tallestHeight);
    });
  });
}


// COLOR SWATCH ON COLLECTION PAGE
theme.colorSwatches = (function() {
  $('.grid-view-item .swatches li:not(.noImg)').click(function() {
   var color = $(this),
    	newImage = $(this).attr('rel'),
        colorlist = $(this).parents('.swatches').children(".swatch");
    $(this).parents('.grid-view-item').find('.grid-view-item__link').addClass("showLoading");
    $(this).parents('.grid-view-item').find('.variantImg').attr({ src: newImage });
    $(this).parents('.grid-view-item').find('.variantImg').load(function(){
      	$(colorlist).removeClass("active");
      	$(color).addClass("active");
    	$(this).parents('.grid-view-item').find('.grid-view-item__link').addClass("showVariantImg");
      	$(this).parents('.grid-view-item').find('.grid-view-item__link').removeClass("showLoading");
    });
    return false;
  });
});
$(theme.colorSwatches);

theme.instagram = {};
theme.instagramSection = (function() {
  function instagramSection(container) {
    var $container = this.$container = $(container),
    	sectionId = $container.attr('data-section-id'),
        imgfrom = $container.attr('data-from'),
        user = $container.attr('data-user'),
        tag = $container.attr('data-tag'),
        imagesize = $container.attr('data-image'),
        num_photos = $container.attr('data-count');
    if(imgfrom == "user") {
      $.instagramFeed({'username': user, 'container': "#instafeed"+sectionId, 'items': num_photos, 'styling': false, 'image_size': imagesize });
    } else {
      $.instagramFeed({ 'tag': tag, 'container': "#instafeed"+sectionId, 'items': num_photos, 'styling': false, 'image_size': imagesize });
    }
    $("#instafeed"+sectionId+".insta-slick").slick();
  }
  return instagramSection;
})();


// 	POPULAR PRODUCT SLIDER
theme.PopularProdSlider = (function() {     
    $('.list-sidebar-products .grid-products').slick({
      dots: false,
      infinite: true,
      speed: 300,
      centerPadding: 20,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true
    });

})();


theme.collectionListBox = (function(){  
    function collectionList(container) {
    var $container = this.$container = $(container),
      	sectionId = $container.attr('data-section-id'),
        collectionSlider = this.productSlider = '#cs-' + sectionId + ' .collection-grid .grid',
    	slidercount = $container.attr('data-section-slide');
        slidercountipad = $container.attr('data-section-slide-ipad');
     	slidercountmobile = $container.attr('data-section-slide-mobile');
    
     // Slide start
        
   $(collectionSlider).slick({
      dots: false,
      infinite: true,     
      slidesToShow:slidercount,     
      speed:600,    
      slidesToScroll: 1, 
      responsive: [        
        {
          breakpoint: 999,
          settings: {
            slidesToShow: slidercountipad,
            slidesToScroll: 1
          }
        },                
        {
          breakpoint: 767,
          settings: {
            slidesToShow: slidercountmobile,
            slidesToScroll: 1
          }
        }
      ]
    });
    // End Slider     
	
  }   
  return collectionList;  
})();

theme.ajaxCart = function(){
  	var drawerTimeout = null;
  	theme.cartAddingInProgress = false;

  	function normalizeProductQty(val) {
      val = parseInt(val, 10);
      if (isNaN(val) || val < 1) {
        return 1;
      }
      return val;
    }

    function resetProductQuantityFields() {
      $('.product-form__item--quantity .qty, .product-form__item--quantity input[name="quantity"]').val('1');
    }

    function bindProductQuantity() {
      $(document).off('input.productQty blur.productQty change.productQty', '.product-form__item--quantity .qty, .product-form__item--quantity input[name="quantity"]')
        .on('input.productQty', '.product-form__item--quantity .qty, .product-form__item--quantity input[name="quantity"]', function() {
          var $input = $(this);
          var val = String($input.val()).replace(/[^\d]/g, '');

          if (val === '') {
            return;
          }

          if (parseInt(val, 10) < 1) {
            $input.val('1');
            return;
          }

          $input.val(String(parseInt(val, 10)));
        })
        .on('blur.productQty change.productQty', '.product-form__item--quantity .qty, .product-form__item--quantity input[name="quantity"]', function() {
          $(this).val(normalizeProductQty($(this).val()));
        });

      $(document).off('click.productQty', '.product-form__item--quantity .qtyBtn')
        .on('click.productQty', '.product-form__item--quantity .qtyBtn', function(evt) {
          evt.preventDefault();
          var $field = $(this).closest('.qtyField');
          var $input = $field.find('.qty, input[name="quantity"]');
          var oldValue = normalizeProductQty($input.val());
          var newVal = oldValue;

          if ($(this).is('.plus')) {
            newVal = oldValue + 1;
          } else if (oldValue > 1) {
            newVal = oldValue - 1;
          }

          $input.val(newVal);
        });

      $(document).off('submit.productQty', 'form.product-form')
        .on('submit.productQty', 'form.product-form', function() {
          var $qtyInput = $(this).find('input[name="quantity"]');
          if ($qtyInput.length) {
            $qtyInput.val(normalizeProductQty($qtyInput.val()));
          }
        });
    }

  	quantityChange();
    bindProductQuantity();
    gridAddToCart();
    prodAddToCart();
    bindUpsellAddToCart();
	
	$(".continue-shopping, .modalOverly, .closeDrawer").click(function(){
        if ($('body').hasClass('show-cart-error') && theme.CartHelpers && theme.CartHelpers.hideCartError) {
          theme.CartHelpers.hideCartError();
          return;
        }
        clearTimeout(drawerTimeout), $(".modal").fadeOut(200);
    	$("body").removeClass("loading showOverly show-cart-error");
    });
  	function quantityChange() {
  		$(".qtyBtn").not('.cart .qtyBtn').on("click", function() {
         var oldValue = $(this).parents(".qtyField").children(".cart__qty-input").val(),
             newVal = 1;

         if ($(this).is(".plus")) {
           newVal = parseInt(oldValue) + 1;
         } else if (oldValue > 1) {
           newVal = parseInt(oldValue) - 1;
         }

         $(this).parents(".qtyField").children(".cart__qty-input").val(newVal);

       });
    }
  	function gridAddToCart() {
      $(".add-to-cart").click(function(i) {
        i.preventDefault();
          if (theme.ajax_cart) {
            var att = $(this).attr("id"),
            	qty = $(this).attr("rel");
            addinToCart(att, qty);
          } else {
            //alert('dfsdfsfdf');
            $(this).parent().submit();
          }
        return;
      });
    }
    function resolveAddToCartVariantId($btn) {
      var variantId = parseInt($btn.data('variant-id'), 10);
      if (variantId) {
        return variantId;
      }

      var $form = $btn.closest('.product-form');
      var att = null;

      if ($form.length) {
        att = $form.find('select[name="id"]').val() || $form.find('input[name="id"]').val();
      }

      if (!att) {
        var $sticky = $btn.closest('[id^="StickyAddToCart-"]');
        if ($sticky.length) {
          var stickySectionId = $sticky.attr('id').replace('StickyAddToCart-', '');
          att = $('#ProductSelect-' + stickySectionId).val();
        }
      }

      if (!att) {
        var $section = $btn.closest('[id^="ProductSection-"]');
        if ($section.length) {
          var sectionId = $section.attr('id').replace('ProductSection-', '');
          att = $('#ProductSelect-' + sectionId).val();
        }
      }

      if (!att) {
        var buttonId = $btn.attr('id');
        if (buttonId && /^\d+$/.test(buttonId)) {
          att = buttonId;
        }
      }

      variantId = parseInt(att, 10);
      return variantId || null;
    }

    function prodAddToCart(){
      $(document).off('click.ajaxCart', '.product-form__cart-submit').on('click.ajaxCart', '.product-form__cart-submit', function(i) {
        i.preventDefault();
        if ($(this).attr("disabled") === "disabled" || $(this).prop('disabled')) {
          return;
        }
        var isQuickView = $(this).closest('#content_quickview').length > 0;
        if (isQuickView && theme.CartHelpers && theme.CartHelpers.closeQuickViewPopup) {
          theme.CartHelpers.closeQuickViewPopup();
        }
        if (theme.ajax_cart) {
          var $btn = $(this);
          var $form = $btn.closest('.product-form');
          var att = resolveAddToCartVariantId($btn);
          var $qtyInput = $form.length ? $form.find('input[name=quantity]') : $('#Quantity');
          var qty = normalizeProductQty($qtyInput.val());
          $qtyInput.val(qty);

          if (!att) {
            if (theme.CartHelpers && theme.CartHelpers.showCartError) {
              theme.CartHelpers.showCartError('Please select a product option before adding to cart.');
            }
            return;
          }

          addinToCart(att, qty);
        } else {
          $(this).closest('.product-form').length
            ? $(this).closest('.product-form').submit()
            : $('form.product-form').first().submit();
        }
      });
    }
    function bindUpsellAddToCart() {
      $(document).off('click.productUpsell', '[data-upsell-add]').on('click.productUpsell', '[data-upsell-add]', function(evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();

        var $btn = $(this);

        if ($btn.prop('disabled') || $btn.hasClass('is-loading')) {
          return;
        }

        var variantId = parseInt($btn.data('variant-id'), 10);
        var qty = parseInt($btn.data('quantity'), 10) || 1;

        if (!variantId) {
          return;
        }

        addUpsellToCart(variantId, qty, $btn);
      });
    }

    function addUpsellToCart(variantId, qty, $btn) {
      if (theme.cartAddingInProgress) {
        return;
      }

      theme.cartAddingInProgress = true;
      var $activeButtons = $btn && $btn.length ? $btn : $('[data-upsell-add]');
      $activeButtons.prop('disabled', true).addClass('is-loading').attr('aria-busy', 'true');

      theme.CartHelpers.fetchCartAdd(variantId, qty, { skipSellingPlan: true })
        .then(function(cart) {
          theme.CartHelpers.applyCartState(cart, { openDrawer: true });
        })
        .catch(function(errorBody) {
          var errormsg = (errorBody && errorBody.description) ? errorBody.description : 'Unable to add item to cart.';
          if (theme.CartHelpers && theme.CartHelpers.showCartError) {
            theme.CartHelpers.showCartError(errormsg);
          } else {
            $(".error-message").text(errormsg);
            showDrawer("#errorDrawer");
          }
        })
        .finally(function() {
          theme.cartAddingInProgress = false;
          $activeButtons.prop('disabled', false).removeClass('is-loading').removeAttr('aria-busy');
          $("body").removeClass("loading");
        });
    }

    function addinToCart(att, qty){
      var variantId = parseInt(att, 10);
      if (!variantId || isNaN(variantId)) {
        if (theme.CartHelpers && theme.CartHelpers.showCartError) {
          theme.CartHelpers.showCartError('Please select a product option before adding to cart.');
        }
        return;
      }

      if (theme.cartAddingInProgress) {
        return;
      }

      theme.cartAddingInProgress = true;
      var $activeButtons = $(".product-form__cart-submit:not(:disabled), .add-to-cart:not(:disabled)");
      $activeButtons.prop('disabled', true);
      $("body").addClass("loading");

      theme.CartHelpers.fetchCartAdd(variantId, qty)
        .then(function(cart) {
          resetProductQuantityFields();
          theme.CartHelpers.applyCartState(cart, { openDrawer: true });
        })
        .catch(function(errorBody) {
          var errormsg = (errorBody && errorBody.description) ? errorBody.description : 'Unable to add item to cart.';
          $("body").removeClass("loading");
          if (theme.CartHelpers && theme.CartHelpers.showCartError) {
            theme.CartHelpers.showCartError(errormsg);
          } else {
            $(".error-message").text(errormsg);
            showDrawer("#errorDrawer");
          }
        })
        .finally(function() {
          theme.cartAddingInProgress = false;
          $activeButtons.prop('disabled', false);
          $("body").removeClass("loading");
        });
    }
  	function showDrawer(i){
      clearTimeout(drawerTimeout);
      $(".modal").not(i).hide();
      $("body").addClass("loading showOverly");
      $(i).stop(true, true).fadeIn(500);
      drawerTimeout = setTimeout(function() {
          $("body").removeClass("loading showOverly"), $(i).fadeOut(200)
      }, 8000);
    }
};
$(theme.ajaxCart);

$(document).ready(function() {
  var sections = new theme.Sections();

  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('collection-template', theme.collectionView);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('carousel-section', theme.prodcarouselSection);
  sections.register('quotes', theme.Quotes);
  sections.register('masonary', theme.masonary);
  sections.register('instagram', theme.instagramSection);
  sections.register('collection-box', theme.collectionListBox); 
  sections.register('product-template', theme.PopularProdSlider);
  
      // Show/Hide dropdown

     $('.shopify-currency-form select').on('change', function() {
        $(this)
        .parents('form')
        .submit();
      });
  
  	$('.logo-bar').slick({
    	dots: false,
        infinite: true,
        speed: 600,
        slidesToShow: 6,
		slidesToScroll: 1,
		responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1                           
            }
          },
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
    });
});

var resizeTimer;
  $(window).resize(function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      $(window).trigger('delayed-resize');
    }, 250);
});

theme.init = function() {
  theme.customerTemplates.init();

  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

};

$(theme.init);

!function($) {
  
  //alert("working");
  $(document).ready(function() {
	scrollpage();
  }), $(window).resize(function() {
    
  });
  
 // NEWSLETTER: show once per user after delay (default 10s)
  var NEWSLETTER_STORAGE_KEY = 'newsletter_popup_shown';

  function newsletterHasBeenShown() {
    try {
      if (window.localStorage && localStorage.getItem(NEWSLETTER_STORAGE_KEY) === 'true') {
        return true;
      }
    } catch (e) {}
    return typeof Cookies !== 'undefined' && Cookies.get('visited') === 'true';
  }

  function markNewsletterShown() {
    try {
      if (window.localStorage) {
        localStorage.setItem(NEWSLETTER_STORAGE_KEY, 'true');
      }
    } catch (e) {}
    if (typeof Cookies !== 'undefined') {
      Cookies.set('visited', 'true', { expires: 365, path: '/' });
    }
  }

  function hideNewsletterPopup() {
    $("#newsletter-modal").fadeOut();
    $(".newsletter-wrap").fadeOut().attr('aria-hidden', 'true');
    markNewsletterShown();
  }

  function showNewsletterPopup() {
    if (newsletterHasBeenShown()) {
      return;
    }
    markNewsletterShown();
    $(".newsletter-wrap").show().attr('aria-hidden', 'false');
    $("#newsletter-modal").show();
  }

  if ($("#newsletter-modal").length) {
    var popupTime = parseInt($("#newsletter-modal").attr("data-time"), 10);
    if (isNaN(popupTime) || popupTime < 0) {
      popupTime = 10000;
    }

    if (!newsletterHasBeenShown()) {
      setTimeout(showNewsletterPopup, popupTime);
    } else {
      $("#newsletter-modal").hide();
      $(".newsletter-wrap").hide().attr('aria-hidden', 'true');
    }
  }

  $(document).on('mouseup', function (e) {
    var $wrap = $(".newsletter-wrap");
    if (!$wrap.is(':visible')) {
      return;
    }
    var container = $("#newsletter-modal");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      hideNewsletterPopup();
    }
  });

  $(document).on('click', '.closepopup', function () {
    hideNewsletterPopup();
  });

  $(document).on('keydown', function (e) {
    if ((e.key === 'Escape' || e.keyCode === 27) && $(".newsletter-wrap").is(':visible')) {
      hideNewsletterPopup();
    }
  });
  
  if($(".notification-bar").length){	
		if(Cookies.get('promotion') != 'true') {   
    		$(".notification-bar").show();      
  		}
  }
  
  // PROMOTION HEADER show-hide
  $(".close-announcement").click(function() {   
    $(".notification-bar").slideUp();  
    Cookies.set('promotion', 'true', { expires: 1});  
  });    
  
  // User Links
   $('.user-menu').click(function(){
    $(".customer-links").slideToggle();
  });
  
  
  scrollpage = function(){
    // STICKY HEADER
    if (theme.fixedHeader){
      $(window).scroll(function(){
          if($(window).width()>1199){
            if($(window).scrollTop()>145){    
              $('.sticky-header').addClass("animated fadeInDown");                   
            } else {
              $('.sticky-header').removeClass("fadeInDown");              
           }
          }
      });
    }
    
    $(window).scroll(function(){    
		if($(this).scrollTop()>300){
        	$("#site-scroll").fadeIn();
      	} else {
        	$("#site-scroll").fadeOut();
      	}
    });
  }
  
   //Footer links for mobiles
  $(".footer-links h5").click(function() {
    if($(window).width() < 991){
      $(this).toggleClass("active");
      $(this).next().slideToggle();
  	}
  });   
  
  // SITE SCROLLER
  $("#site-scroll").click(function() {
    $("html, body").animate({ scrollTop: 0 }, 1000);
    return false;
  }); 
  
  
  
   // Site Animation
  if(theme.animationMobile) {
      if($(window).width() < 767) {
          $('.wow').removeClass('wow');   
      }
  }
  if(theme.animation) {
    new WOW().init();
  }
  
  /// Slieshow Parallax
  $.stellar({
  	 horizontalScrolling: false,
  	 verticalOffset: 40
  });

  // SITE SCROLLER
  $(".video-poster-text").click(function() {
    videoFrame = $(this).prev(".play-video").find("iframe");
    videoUrl = $(videoFrame).attr("src");
    $(videoFrame).attr("src", videoUrl + '&autoplay=1');
    $(this).fadeOut("slow");
  });
  
  
  // Hide Customer Links on document click
  $("body").click(function(event ){
      var $target = $(event.target);
      if(!$target.parents().is(".user-menu") && !$target.is(".customer-links")){
		$("body").find(".customer-links").slideUp();
      }
  }); 
  
                  
}(jQuery);
